import React, { Component } from "react";
import axios from "axios";
import { apiUrl, apiUrl4, apiUrl3, apiUrl2, report } from "../../config/config";

import classnames from "classnames";
import Select from "react-select";
import $ from "jquery";
import Modal from "react-modal";
import "./patientinfo.css";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import LinearProgress from "@material-ui/core/LinearProgress";
import { FormatAlignLeft, Label } from "@material-ui/icons";
import { Toaster, toast } from "react-hot-toast";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Countdown from "react-countdown";
Modal.setAppElement("#root");

class PatientInfo extends Component {
  constructor() {
    super();
    const menus = [
      { title: "Verifier Home", url: "/verifier-home" },
      { title: "Patient list", url: "/patient-list" },
      { title: "Labled Patients", url: "/labled-patients" },
      { title: "Verified", url: "/verification-completed" },

    ];
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(3, 0, { title: "Device Deatils", url: "/device-details" });
      menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
    }

    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
    }
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
    }
    if (localStorage.getItem("verifiertype") === "8") {
      menus.splice(6, 0, { title: "Support Web", url: "/support-homeweb" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
    }
    if (localStorage.getItem("AdminUser") === "8") {
      menus.splice(6, 0, {
        title: "Supported Person",
        url: "/supported-persons",
      });
     
      }
       if (localStorage.getItem("AdminUser") === "8") {
        menus.splice(6, 0, {
          title: "Reset Password",
          url: "/ResetPassword",
        });
    }
    this.state = {
      menus,
      profileLink: "verifier-profile",
      patients: [],
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      errors: {},
      userid: "",
      showCsvModal: false,
      csvParam1: "",
      csvParam2: "",

      hospital: "",
      ip_op: "",
      BatteryPercentage: "",
      backup: "",
      patient_name: "",
      phone: "",

      indication: "",

      doctors: [],
      doctor_id: "",
      doctor_name: "Choose",
      data: { rows: [] },
      prog_data: 0,
      loading: false,
      time: "",
      serial_no: "",
      RecordingStatus: "",
      device_id: "",
      Mac_id: "",
      customer_details: "",

      activity: "Rest",
      act_duration: "5",
      addNote: "",
      selectedDoctor: null,
      search: "",
      pageSize: 50,
      sortField: null,
      sortDirection: "asc",
      pacemaker: false,
      supportPersons: [], // list from API
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],

      supportPerson: "", // selected support person id
      supportLevel: "",
      supportedMatter: "",
      Confirmation: "",
      filetype: "",
      dob: null,
      loadingEditModal: false, // Added loading state for edit modal
      data: {},
      prioritizeData: "No",
      clinicalCondition: "",
      newComment: "",
      // Send-report state
      mailuserid: "",
      customermailid: "",
      whatsappNumber: "",
      mailsubject: "",
      arrythymia: "",
      device_mac: "",
      patientmailid: "",
      patientmailsubject: "",
      patientwhatsappNumber: "",
      selectedType: "customer",
      setCompletionDate: "",
      // socketNew: socketIOClient("http://edit.mybiocalculus.com:5000"),
    };
    this.selectItem = this.selectItem.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.fetchPatients = this.fetchPatients.bind(this);
    this.handleDoctorChange = this.handleDoctorChange.bind(this);
    this.submitComment = this.submitComment.bind(this);
    this.sentWhatsappReport = this.sentWhatsappReport.bind(this);
    this.sentWhatsappReportPatient = this.sentWhatsappReportPatient.bind(this);
    // this.handlePageChange = this.handlePageChange.bind(this);
  }
  openCsvModal = () => {
    this.setState({ showCsvModal: true });
  };

  closeCsvModal = () => {
    this.setState({ showCsvModal: false });
  };

  // Lightweight comment-only load (no full getInfo API chain)
  getCommentInfo = (e) => {
    const userid = e.currentTarget.id;
    this.setState({ userid });
    const patient = (this.state.patients || []).find(p => p._id === userid);
    if (patient) {
      this.setState({
        comments: patient.comments || "",
        patient_name: patient.name || "",
      });
    }
  };

  getCurrentDateTime = () => {
    const now = new Date();
    const pad = n => String(n).padStart(2, "0");
    return `${now.getFullYear()}-${pad(now.getMonth()+1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`;
  };

  clearShareReportState = () => {
    this.setState({
      customermailid: "", whatsappNumber: "", mailsubject: "",
      arrythymia: "", patientmailid: "", patientmailsubject: "",
      patientwhatsappNumber: "", selectedType: "customer",
    });
  };

  validateEmails = (emails) => {
    const emailList = emails.split(",").map(e => e.trim());
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailList.every(e => re.test(e));
  };

  validateWhatsAppNumbers = (nums) => {
    const list = nums.split(",").map(n => n.trim().replace(/\D/g, ""));
    return list.every(n => n.length === 10);
  };

  // sentMailReport removed (mail UI removed)

  sentWhatsappReport = async () => {
    const number = this.state.whatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";
    if (!arrythymia || !number) { toast.error("Enter WhatsApp number to proceed"); return; }
    if (!this.validateWhatsAppNumbers(number)) { toast.error("Please enter valid 10-digit WhatsApp number(s)."); return; }
    const requestBody = { user_id: userid, arrythymia, number, scheduledTime: this.state.setCompletionDate };
    fetch(`${apiUrl}api/common/schedule_whatsapp_New`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody),
    })
      .then(r => r.json().then(d => { if (!r.ok) throw new Error(d.message || "Failed"); return d; }))
      .then(() => { toast.success("WhatsApp message sent!"); this.setState({ whatsappNumber: "", arrythymia: "" }); $(".closePopup").click(); })
      .catch(err => toast.error(err.message || "Error sending WhatsApp."));
  };

  // sentMailReportPatient removed (mail UI removed)

  sentWhatsappReportPatient = async () => {
    const number = this.state.patientwhatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";
    if (!arrythymia || !number) { toast.error("Enter WhatsApp number to proceed"); return; }
    const requestBody = { user_id: userid, arrythymia, number, scheduledTime: this.state.setCompletionDate };
    fetch(`${apiUrl}api/common/schedule_whatsapp_New`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(requestBody),
    })
      .then(r => r.json().then(d => { if (!r.ok) throw new Error(d.message || "Failed"); return d; }))
      .then(() => { toast.success("WhatsApp sent!"); })
      .catch(err => toast.error(err.message || "Error."));
  };

  submitComment = async (e) => {
    const userid = e.currentTarget.id;
    const newText = (this.state.newComment || "").trim();
    if (!newText) return;
    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    const existing = (this.state.comments || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;
    try {
      await axios.post(`${apiUrl}api/patients/addComment/${userid}`, { comments });
      $(".closePopup").click();
      this.setState({ newComment: "", comments: "" });
      this.fetchPatients(this.state.currentPage);
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };

  handleCsvParamChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleCsvDownload = () => {
    // Call your existing Downloadcsv function with params
    this.Downloadcsv(this.state.csvParam1, this.state.csvParam2);
    this.closeCsvModal();
  };

  componentDidMount() {
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
      return;
    }
    this.fetchData();
    this.fetchPatients(this.state.currentPage);
    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var newstat = this;

    /*socket.on('connect', function(){console.log('connected')});
    socket.on('connect_error', function(err){console.log(err)});
    socket.on('data', function(data){


      newstat.setState({"loading":true});
      
      console.log(newstat.state.loading)
    });
    socket.on('disconnect', function(){console.log('disconnected')});*/
  }
  fetchData = () => {
    const verifiertype = localStorage.getItem("verifiertype");
    this.setState({ verifiertype });

    // Cache doctors for 10 minutes — avoids repeat API call on every
    // page open. Bug we just fixed: a previous empty/non-array cache
    // (network hiccup at first fetch) would stick for 10 minutes and
    // leave the doctor dropdown blank. Now: parse defensively, treat
    // an empty array as stale, and re-fetch with a catch handler.
    const cached = sessionStorage.getItem("cachedDoctors");
    const cachedTime = sessionStorage.getItem("cachedDoctorsTime");
    let cachedArr = null;
    try { cachedArr = cached ? JSON.parse(cached) : null; } catch (e) {}
    const isFresh =
      Array.isArray(cachedArr)
      && cachedArr.length > 0
      && cachedTime
      && (Date.now() - Number(cachedTime)) < 10 * 60 * 1000;

    if (isFresh) {
      this.setState({ doctors: cachedArr });
    } else {
      axios.get(apiUrl + "api/users/alldoctors")
        .then((res) => {
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.setState({ doctors: res.data });
            sessionStorage.setItem("cachedDoctors", JSON.stringify(res.data));
            sessionStorage.setItem("cachedDoctorsTime", String(Date.now()));
          }
          // If the response is empty/invalid, leave the cache alone so
          // the next mount tries again — don't poison it with [].
        })
        .catch((err) => {
          // Silent — leave state.doctors at its initial value, but log
          // for debugging so we don't lose the failure entirely.
          console.warn("[PatientInfo] /alldoctors fetch failed:", err && err.message);
        });
    }
    // axios
    //   .all([
    //     axios.get(apiUrl + "api/users/getVerifierPatientsPercentage"),
    //     axios.get(apiUrl + "api/users/allverifiers"),
    //   ])
    //   .then(
    //     axios.spread((patientsRes, verifiersRes) => {
    //       const filteredPatients = patientsRes.data.sortedPatients.filter(
    //         (patient) =>
    //           patient.Confirmation === "Yes" || patient.Confirmation === "No"
    //       );

    //       this.setState(
    //         {
    //           patients: filteredPatients,
    //           allverifiers: verifiersRes.data,
    //         },
    //         () => {
    //           // Sorting logic remains unchanged
    //           const sortedPatients = this.state.patients
    //             .slice()
    //             .sort((a, b) => {
    //               // Helper: parse date
    //               function parseDate(dateStr, isIso) {
    //                 if (!dateStr) return new Date(0);
    //                 if (isIso) return new Date(dateStr);
    //                 let formatted = dateStr.replace(" ", "T");
    //                 if (!/Z|[+-]\d{2}:?\d{2}$/.test(formatted)) {
    //                   formatted += "+00:00";
    //                 }
    //                 return new Date(formatted);
    //               }
    //               // Get time left (negative means timer over)
    //               function getTimeLeft(patient) {
    //                 const now = new Date();
    //                 const date = patient.ConfirmupdatedDate
    //                   ? parseDate(patient.ConfirmupdatedDate, true)
    //                   : parseDate(patient.updatedDate, false);
    //                 let timeLimit = 4;
    //                 if (
    //                   patient.deviceInfo &&
    //                   patient.deviceInfo.priority !== undefined
    //                 ) {
    //                   switch (patient.deviceInfo.priority) {
    //                     case 1:
    //                       timeLimit = 1;
    //                       break;
    //                     case 2:
    //                       timeLimit = 2;
    //                       break;
    //                     case 3:
    //                       timeLimit = 3;
    //                       break;
    //                     case 4:
    //                       timeLimit = 4;
    //                       break;
    //                     case 5:
    //                       timeLimit = 5;
    //                       break;
    //                     default:
    //                       timeLimit = 4;
    //                   }
    //                 }
    //                 let exp_device =
    //                   patient.exp_device_use_days === 24
    //                     ? 1
    //                     : patient.exp_device_use_days === 48
    //                     ? 2
    //                     : patient.exp_device_use_days === 72
    //                     ? 3
    //                     : patient.exp_device_use_days;
    //                 const allowedMs = timeLimit * exp_device * 60 * 60 * 1000;
    //                 return date.getTime() + allowedMs - now.getTime();
    //               }
    //               // 1. Sort by report_status: 0, then 2, then 6
    //               const statusOrder = { 0: 1, 2: 2, 6: 3 };
    //               const aStatus = statusOrder[a.report_status] || 99;
    //               const bStatus = statusOrder[b.report_status] || 99;
    //               if (aStatus !== bStatus) {
    //                 return aStatus - bStatus;
    //               }
    //               // 2. For report_status == 0, sort timer over first, then others by time left ascending
    //               if (aStatus === 1) {
    //                 const aTimeLeft = getTimeLeft(a);
    //                 const bTimeLeft = getTimeLeft(b);
    //                 // Timer over (negative time left) comes first
    //                 if (aTimeLeft < 0 !== bTimeLeft < 0) {
    //                   return aTimeLeft < 0 ? -1 : 1;
    //                 }
    //                 // Otherwise, sort by time left ascending (closer to timer over first)
    //                 return aTimeLeft - bTimeLeft;
    //               }
    //               // 3. For report_status == 2, sort timer over first, then others by time left ascending
    //               if (aStatus === 2) {
    //                 const aTimeLeft = getTimeLeft(a);
    //                 const bTimeLeft = getTimeLeft(b);
    //                 if (aTimeLeft < 0 !== bTimeLeft < 0) {
    //                   return aTimeLeft < 0 ? -1 : 1;
    //                 }
    //                 return aTimeLeft - bTimeLeft;
    //               }
    //               // 4. For report_status == 3, sort timer over first, then others by time left ascending
    //               if (aStatus === 3) {
    //                 const aTimeLeft = getTimeLeft(a);
    //                 const bTimeLeft = getTimeLeft(b);
    //                 if (aTimeLeft < 0 !== bTimeLeft < 0) {
    //                   return aTimeLeft < 0 ? -1 : 1;
    //                 }
    //                 return aTimeLeft - bTimeLeft;
    //               }
    //               // 5. Otherwise, fallback to priority
    //               const priorityA =
    //                 a.deviceInfo && a.deviceInfo.priority !== undefined
    //                   ? a.deviceInfo.priority
    //                   : 4;
    //               const priorityB =
    //                 b.deviceInfo && b.deviceInfo.priority !== undefined
    //                   ? b.deviceInfo.priority
    //                   : 4;
    //               return priorityA - priorityB;
    //             });

    //           const data = {
    //             columns: [
    //               { label: "SL NO", field: "slno", sort: "asc", width: 0.5 },
    //               {
    //                 label: "PATIENT ID",
    //                 field: "patientId",
    //                 sort: "asc",
    //                 width: 5,
    //               },
    //               {
    //                 label: "ADDED DATE",
    //                 field: "added_date",
    //                 sort: "asc",
    //                 width: 5,
    //               },
    //               { label: "NAME", field: "name", sort: "asc", width: 5 },
    //               {
    //                 label: "DISTRIBUTOR",
    //                 field: "distributor",
    //                 sort: "disabled",
    //                 width: 5,
    //               }, // Existing column
    //               {
    //                 label: "DOCTOR NAME",
    //                 field: "doctor_name",
    //                 sort: "asc",
    //                 width: 5,
    //               },
    //               {
    //                 label: "Priority",
    //                 field: "priority",
    //                 sort: "disabled",
    //                 width: 5,
    //               }, // Existing column
    //               {
    //                 label: "Pace",
    //                 field: "pacemaker",
    //                 sort: "disabled",
    //                 width: 5,
    //               },
    //               {
    //                 label: "ACTION",
    //                 field: "action",
    //                 sort: "disabled",
    //                 width: 5,
    //               },
    //               ...(this.state.verifiertype === "8"
    //                 ? [
    //                     {
    //                       label: "REPORT",
    //                       field: "report",
    //                       sort: "disabled",
    //                       width: 5,
    //                     },
    //                   ]
    //                 : []),
    //               {
    //                 label: "MONITORING",
    //                 field: "monitoring_duration",
    //                 sort: "disabled",
    //                 width: 1,
    //               }, // Existing column
    //             ],
    //             rows: [],
    //           };

    //           sortedPatients.forEach((patient, i) => {
    //             const Priority =
    //               (patient.deviceInfo && patient.deviceInfo.Priority) || 4; // Set Priority value

    //             // Variable to store the final time value
    //             let finalTime;

    //             // Ensure the date fields are not undefined or null before splitting
    //             if (patient.ConfirmupdatedDate) {
    //               // Split the 'ConfirmupdatedDate' by 'T' to get the date and time parts
    //               let confirmButtonTime = patient.ConfirmupdatedDate.split("T");

    //               // Get the date part before 'T'
    //               let confirmDate = confirmButtonTime[0]; // '2024-11-29'

    //               // Get the time part after 'T'
    //               let confirmTime = confirmButtonTime[1]
    //                 ? confirmButtonTime[1].split("Z")[0] // Remove 'Z' if it exists
    //                 : ""; // If no time part, default to an empty string

    //               // Handle removing milliseconds (if any) from confirmTime
    //               if (confirmTime) {
    //                 let time = confirmTime.split(".")[0]; // Get time without milliseconds
    //                 const confirmbtnTime = confirmDate + " " + time; // Add a space between date and time
    //                 // console.log("Confirm button time:", confirmbtnTime);

    //                 // Assign confirmbtnTime to finalTime if available
    //                 finalTime = confirmbtnTime;
    //               } else {
    //                 // console.log("Confirm Time is empty or invalid");
    //               }
    //             } else {
    //               // console.log("ConfirmupdatedDate is undefined or null");
    //             }

    //             // Check and split the 'updatedDate' if it's available
    //             if (patient.updatedDate) {
    //               // Split the 'updatedDate' by space to separate date and time
    //               let updatedDateTime = patient.updatedDate.split(" ");

    //               // Get the date part before the space
    //               let updatedDate = updatedDateTime[0]; // '2024-11-29'

    //               // Get the time part after the space
    //               let updatedTime = updatedDateTime[1]; // '10:28:34'

    //               // console.log("Updated Date:", updatedDate, updatedTime);

    //               // Combine updatedDate and updatedTime with a space between them
    //               const uploadedTime = updatedDate + " " + updatedTime;

    //               // Assign uploadedTime to finalTime if confirmbtnTime was not set
    //               if (!finalTime) {
    //                 finalTime = uploadedTime;
    //               }
    //             } else {
    //               // console.log("UpdatedDate is undefined or null");
    //             }

    //             // Log the final time
    //             // console.log("Final Time:", finalTime);

    //             // Get the current time
    //             const now = new Date();

    //             // Convert finalTime to Date object
    //             const finalDate = new Date(finalTime);

    //             // Calculate the time difference in milliseconds
    //             const timeDifference = now - finalDate; // in milliseconds

    //             // Convert time difference to hours
    //             const hoursDifference = timeDifference / (1000 * 60 * 60); // milliseconds to hours

    //             // Set the time limit based on priority
    //             let timeLimit;
    //             switch (Priority) {
    //               case 1:
    //                 timeLimit = 1; // 1 hours
    //                 break;
    //               case 2:
    //                 timeLimit = 2; // 3 hours
    //                 break;
    //               case 3:
    //                 timeLimit = 3;
    //               case 4:
    //                 timeLimit = 4; // 4 hours
    //                 break;
    //               case 5:
    //                 timeLimit = 5; // 8 hours
    //                 break;
    //               default:
    //                 timeLimit = 4; // 10 hours (for priority 5, as an example)
    //             }

    //             // Calculate the percentage of time used

    //             let exp_device =
    //               patient.exp_device_use_days === 24
    //                 ? 1
    //                 : patient.exp_device_use_days === 48
    //                 ? 2
    //                 : patient.exp_device_use_days === 72
    //                 ? 3
    //                 : patient.exp_device_use_days;

    //             let timePercentage =
    //               // (hoursDifference / (timeLimit * exp_device)) * 100;
    //               (hoursDifference / (timeLimit * exp_device)) * 100; // Calculate the percentage of time used
    //             // *
    //             // patient.exp_device_use_days
    //             if (timePercentage > 100) {
    //               timePercentage = 100; // Limit to 100% if the time exceeds the limit
    //             }
    //             // Calculate the completion rate (percentage per hour)
    //             // Calculate the completion rate (percentage per hour)
    //             const completionRate = timePercentage / hoursDifference; // percentage per hour

    //             // Predict the total time to complete 100% (in hours)
    //             const totalCompletionTime = 100 / completionRate; // in hours

    //             // Calculate the remaining time to complete (in hours)
    //             const remainingTimeInHours =
    //               totalCompletionTime - hoursDifference;

    //             // Convert the remaining time to minutes
    //             const remainingTimeInMinutes = remainingTimeInHours * 60;
    //             const totalSeconds = remainingTimeInMinutes * 60;
    //             // Convert minutes into hours and minutes
    //             const hours = Math.floor(remainingTimeInMinutes / 60); // Extract whole hours
    //             const minutes = Math.round(remainingTimeInMinutes % 60); // Get the remaining minutes
    //             const seconds = Math.floor(totalSeconds % 60);
    //             // console.log(`hr:${hours} min:${minutes} sec:${seconds}`);
    //             // Log the predicted remaining time
    //             // console.log(
    //             //   `Predicted Remaining Time: ${hours} hours and ${minutes} minutes`
    //             // );

    //             // console.log("name", patient.name);
    //             // console.log("percetage", timePercentage);
    //             // console.log("timediff", timeDifference);
    //             // console.log("time limit", timeLimit);

    //             // Log the result
    //             // console.log(`Time used: ${hoursDifference.toFixed(2)} hours`);
    //             // console.log(`Time limit for Priority ${Priority}: ${timeLimit} hours`);
    //             // console.log(`Percentage of time used: ${timePercentage.toFixed(2)}%`);
    //             const percentage = timePercentage.toFixed(2);
    //             const devicemac =
    //               patient && patient.deviceInfo && patient.deviceInfo.mac_id;
    //             // console.log("patient", devicemac);
    //             const Distributor_name =
    //               patient &&
    //               patient.deviceInfo &&
    //               patient.deviceInfo.customer_details;
    //             const devicepriority =
    //               patient && patient.deviceInfo && patient.deviceInfo.priority;

    //             const totalEcgValues = patient.ecgValues.length;
    //             const verifiedEcgValues = patient.ecgValues.filter(
    //               (ecgValue) => ecgValue.verifyStatus === 1
    //             );
    //             const verifiedPercentage = `${verifiedEcgValues.length} /${totalEcgValues} `;

    //             const createdData = patient.created_at.split("T");

    //             let url = " ";
    //             let anl_btn_txt = "teststart";
    //             let anl_btn_class = "btn-danger";
    //             let gen_btn_txt = "Not Generated";
    //             let gen_btn_class = "btn-danger";
    //             let report_link = "#";
    //             let report_link_target = "";

    //             if (patient.LastDatasetId !== undefined) {
    //               url =
    //                 patient.backup_status === 0 ||
    //                 patient.backup_status === undefined
    //                   ? `/verifier-unanalysed/${patient._id}/${patient.LastDatasetId}`
    //                   : " ";
    //             }

    //             if (patient.report_status >= 1) {
    //               anl_btn_txt = "Analyzing...";
    //               anl_btn_class = "btn-success";
    //             }

    //             if (patient.report_status >= 2) {
    //               anl_btn_txt = "test";
    //               anl_btn_class = "btn-success";
    //               url =
    //                 patient.backup_status === 0 ||
    //                 patient.backup_status === undefined
    //                   ? `/verifier-chart/${patient._id}/${patient.LastDatasetId}`
    //                   : " ";
    //             }

    //             if (patient.report_status >= 4) {
    //               gen_btn_txt = "In Preparation";
    //               gen_btn_class = "btn-yellow";
    //             }
    //             if (patient.report_status >= 5) {
    //               gen_btn_txt = "Not Generated";
    //               gen_btn_class = "btn-danger";
    //               report_link_target = "_blank";
    //               report_link =
    //                 "https://web.mybiocalculus.com/assets/dist/user_records/" +
    //                 patient._id +
    //                 "/Report" +
    //                 patient._id +
    //                 ".pdf";
    //             }

    //             anl_btn_txt =
    //               patient.backup_status === 0 ||
    //               patient.backup_status === undefined
    //                 ? "TEST3"
    //                 : patient.backup_status === 1
    //                 ? "Retrieve"
    //                 : "Retrieving";

    //             const updateddate = patient.ConfirmupdatedDate
    //               ? patient.ConfirmupdatedDate.replace("T", " ").split(
    //                   ".000Z"
    //                 )[0]
    //               : patient.updatedDate;

    //             data.rows.push({
    //               report_status: patient.report_status,
    //               slno: i + 1,
    //               patientId: patient.device_id,
    //               added_date: createdData[0],

    //               name: patient.name, // Default value
    //               distributor: Distributor_name, // Default value // Ensure `distributor` is populated
    //               doctor_name: patient.doctorName, // Default value
    //               priority: devicepriority || "N/A",
    //               pacemaker:
    //                 patient.hyper_lipidemia === true
    //                   ? "Yes"
    //                   : patient.hyper_lipidemia === false
    //                   ? "No"
    //                   : "N/A",
    //               // Ensure `doctor_name` is populated
    //               action: (
    //                 <React.Fragment>
    //                   <div
    //                     style={{
    //                       margin: "auto",
    //                       width: "132%",
    //                       marginLeft: "-14%",
    //                     }}
    //                   >
    //                     <ProgressBtn
    //                       id={patient._id}
    //                       bc_stat={patient.backup_status}
    //                       onSelectModalComplete={this.handleModalComplete}
    //                       r_stat={patient.report_status}
    //                       socket={this.state.socketNew}
    //                     />
    //                     {this.state.verifiertype === "8" && (
    //                       <button
    //                         type="button"
    //                         id={patient._id}
    //                         dataid2={devicemac}
    //                         dataid3={devicepriority}
    //                         style={{
    //                           float: "left",
    //                           marginRight: "10px",
    //                           width: "47px",
    //                           height: "40px", // optional for fixed height
    //                           display: "flex", // flexbox for centering
    //                           alignItems: "center", // vertical center
    //                           justifyContent: "center", // horizontal center
    //                         }}
    //                         onClick={this.getInfo}
    //                         className="btn btn-warning"
    //                         data-toggle="modal"
    //                         data-target="#editInfoModal"
    //                       >
    //                         Edit
    //                       </button>
    //                     )}
    //                     <button
    //                       key={patient.id}
    //                       id={patient._id}
    //                       hourcomplete={`${hours} hours and ${minutes} minutes`}
    //                       type="button"
    //                       style={{
    //                         float: "left",
    //                         marginRight: "10px",
    //                         width: "57px",
    //                         height: "40px", // optional for fixed height
    //                         display: "flex", // flexbox for centering
    //                         alignItems: "center", // vertical center
    //                         justifyContent: "center", // horizontal center
    //                       }}
    //                       className="btn btn-primary"
    //                       data-toggle="modal"
    //                       onClick={this.getverifiedprogress}
    //                       data-target="#progressinfomodal"
    //                     >
    //                       {verifiedPercentage}
    //                     </button>
    //                     {this.state.verifiertype === "8" && (
    //                       <select
    //                         style={{
    //                           color: "black",
    //                           width: "80px",
    //                           height: "36px",
    //                           float: "left",
    //                           backgroundColor: "gray",
    //                           border: "none",
    //                         }}
    //                       >
    //                         {this.state.allverifiers.filter((verifier) =>
    //                           verifier.patients.includes(patient._id)
    //                         ).length === 0 && (
    //                           <option
    //                             style={{ color: "gray" }}
    //                             disabled
    //                             selected
    //                           >
    //                             Not Assigned
    //                           </option>
    //                         )}
    //                         {this.state.allverifiers
    //                           .filter((verifier) =>
    //                             verifier.patients.includes(patient._id)
    //                           )
    //                           .map((verifier) => (
    //                             <option
    //                               style={{ color: "black" }}
    //                               key={verifier._id}
    //                               value={verifier._id}
    //                             >
    //                               {verifier.name}
    //                             </option>
    //                           ))}
    //                       </select>
    //                     )}

    //                     <button
    //                       type="button"
    //                       id={patient._id}
    //                       style={{
    //                         float: "left",
    //                         marginLeft: "10px",
    //                         width: "130px",
    //                         marginRight: "10px",
    //                       }}
    //                       onClick={this.getInfo}
    //                       className="btn btn-warning"
    //                       data-toggle="modal"
    //                       data-target="#commentinfomodal"
    //                     >
    //                       comments
    //                     </button>

    //                     {this.state.verifiertype === "8" &&
    //                     !patient.ConfirmupdatedDate ? (
    //                       <button
    //                         type="button"
    //                         id={patient._id}
    //                         style={{
    //                           float: "left",
    //                           marginLeft: "0px",
    //                           width: "80px",
    //                           marginRight: "10px",
    //                           backgroundColor: "transparent",
    //                           border: "none",
    //                           fontSize: "30px",
    //                           padding: "10px 20px",
    //                           borderRadius: "5px",
    //                           cursor: "pointer",
    //                         }}
    //                         onClick={this.getConfirmTime}
    //                         className="btn"
    //                       >
    //                         ✅
    //                       </button>
    //                     ) : null}
    //                   </div>
    //                 </React.Fragment>
    //               ),

    //               report: (
    //                 <div
    //                   style={
    //                     this.state.verifiertype !== "8"
    //                       ? { display: "none", marginLeft: "11%", width: "93%" }
    //                       : { marginLeft: "11%", width: "93%" }
    //                   }
    //                 >
    //                   {/* Progress bar to show the percentage of completion */}
    //                   <div style={{ margin: "10px 0" }}>
    //                     <label htmlFor="progressBar">
    //                       TAT:{" "}
    //                       <Countdown
    //                         date={
    //                           Date.now() + remainingTimeInMinutes * 60 * 1000
    //                         }
    //                         renderer={({
    //                           hours,
    //                           minutes,
    //                           seconds,
    //                           completed,
    //                         }) => {
    //                           if (completed) {
    //                             return (
    //                               <span
    //                                 style={{
    //                                   color: "red",
    //                                   display: "flex",
    //                                   alignItems: "center",
    //                                   gap: "6px",
    //                                 }}
    //                               >
    //                                 ⏰ Time Over
    //                               </span>
    //                             );
    //                           } else {
    //                             return (
    //                               <span>
    //                                 {hours}h : {minutes}m : {seconds}s
    //                               </span>
    //                             );
    //                           }
    //                         }}
    //                       />
    //                     </label>
    //                     <div
    //                       style={{
    //                         height: "20px",
    //                         width: "106%",
    //                         backgroundColor: "#e0e0df",
    //                         borderRadius: "5px",
    //                         overflow: "hidden",
    //                         marginTop: "5px",
    //                         position: "relative",
    //                       }}
    //                     >
    //                       {/* Progress bar filled section */}
    //                       <div
    //                         style={{
    //                           height: "100%",
    //                           width: `${timePercentage}%`, // Adjust based on percentage value
    //                           backgroundColor:
    //                             timePercentage >= 80
    //                               ? "#8f0303"
    //                               : timePercentage >= 50
    //                               ? "orange"
    //                               : "#2ecd99", // Red for 80-100%, Orange for 50-79%, Green otherwise
    //                           transition: "width 0.5s ease",
    //                           position: "absolute",
    //                           top: 0,
    //                           left: 0,
    //                         }}
    //                       ></div>

    //                       {/* Centered percentage text */}
    //                       <div
    //                         style={{
    //                           position: "absolute",
    //                           top: 0,
    //                           left: 0,
    //                           height: "100%",
    //                           width: "100%",
    //                           display: "flex",
    //                           alignItems: "center",
    //                           justifyContent: "center",
    //                           fontWeight: "bold",
    //                           color: "#120d0d", // Sets the text color to black
    //                         }}
    //                       >
    //                         {timePercentage.toFixed(2)}%
    //                       </div>
    //                     </div>
    //                   </div>

    //                   <React.Fragment>
    //                     <a
    //                       id={patient._id}
    //                       style={
    //                         gen_btn_class === "btn-yellow"
    //                           ? { backgroundColor: "#2ecd99" }
    //                           : {}
    //                       }
    //                       onClick={() =>
    //                         this.generateReport(
    //                           patient.report_status,
    //                           patient._id
    //                         )
    //                       }
    //                     >
    //                       <button
    //                         type="button"
    //                         className={`btn ${gen_btn_class}`}
    //                         style={
    //                           gen_btn_class === "btn-yellow"
    //                             ? { backgroundColor: "#2ecd99" }
    //                             : {}
    //                         }
    //                       >
    //                         {gen_btn_txt}
    //                       </button>
    //                     </a>
    //                     <input
    //                       type="hidden"
    //                       className="patientLink"
    //                       value={url}
    //                     />
    //                   </React.Fragment>
    //                 </div>
    //               ),

    //               monitoring_duration: (
    //                 <div
    //                   data-toggle="modal"
    //                   data-target="#showblockreport"
    //                   style={{ width: "115px", cursor: "pointer" }}
    //                   onClick={async (e) => {
    //                     const data = await axios.get(
    //                       `${apiUrl}api/common/getblockpatient?userid=${patient._id}`
    //                     );
    //                     console.log("block data", data.data.data.BlockReport);
    //                     this.setState({
    //                       blockReportOption: data.data.data.BlockReport || "No",
    //                     });
    //                     this.setState({ userid: patient._id });
    //                   }}
    //                 >
    //                   {patient.exp_device_use_days}DAYS ({updateddate})
    //                 </div>
    //               ),
    //               TimePercentage: (
    //                 <div
    //                   style={{
    //                     color: "transparent",
    //                     display: "flex",
    //                     position: "absolute",
    //                   }}
    //                 >
    //                   {percentage}
    //                 </div>
    //               ),
    //               hourstocompleted: (
    //                 <div
    //                   style={{
    //                     color: "transparent",
    //                     display: "flex",
    //                     position: "absolute",
    //                   }}
    //                 >
    //                   {`${hours} hours and ${minutes} minutes`}
    //                 </div>
    //               ),
    //             });
    //           });

    //           this.setState({ data: data });
    //           this.setState({ columns: data.columns });
    //           this.setState(
    //             {
    //               rows: data.rows.sort((a, b) => {
    //                 // Extract date from monitoring_duration field: "1DAYS (2025-08-15 21:50:34)"
    //                 const extractDate = (row) => {
    //                   const match = String(
    //                     row.monitoring_duration.props.children
    //                   ).match(/\(([^)]+)\)/);
    //                   // Support both ISO and non-ISO formats
    //                   if (match) {
    //                     // Remove any milliseconds and trailing Z
    //                     let cleaned = match[1].replace(/\.[0-9]+Z?$/, "");
    //                     let date = new Date(cleaned);
    //                     // If still invalid, fallback to original
    //                     if (isNaN(date.getTime())) {
    //                       date = new Date(match[1]);
    //                     }
    //                     return date;
    //                   }
    //                   return new Date(0);
    //                 };
    //                 const dateA = extractDate(a);
    //                 const dateB = extractDate(b);
    //                 // Sort descending: most recent date first
    //                 return dateB - dateA;
    //               }),
    //             },
    //             () => {
    //               // this.applyRowStyles(); // Apply styles to rows

    //               // Bind click events for table rows after setting state
    //               // const table = document.getElementById("table");
    //               // if (table) {
    //               //   table.addEventListener("click", this.handleRowClick);
    //               // }

    //               // Check for TAT notifications after data is loaded
    //               // this.checkTatNotifications();
    //             }
    //           );

    //           // this.setState({ data }, () => {
    //           //   this.applyRowStyles();

    //           //   // Bind click events for table rows
    //           //   const table = document.getElementById("table");
    //           //   table.addEventListener("click", (event) => {
    //           //     const target = event.target;
    //           //     if (
    //           //       target.closest(
    //           //         "td:nth-child(2), td:nth-child(3), td:nth-child(4)"
    //           //       )
    //           //     ) {
    //           //       const url = target
    //           //         .closest("tr")
    //           //         .querySelector(".patientLink").value;
    //           //       if (url !== " ") {
    //           //         window.location.href = url;
    //           //         // console.log("url:", url);
    //           //       }
    //           //     }
    //           //   });
    //           // });
    //         }
    //       );
    //     })
    //   )
    //   .catch((err) => {
    //     console.error("Error fetching data:", err);
    //   });
  };
  handleDoctorChange = (selectedOption) => {
    this.setState({ selectedDoctor: selectedOption });
    // console.log("Selected doctor:", selectedOption);
    // Perform any action needed with the selected doctor
  };

  handleVerifierChange = (selectedOptions) => {
    this.setState({ selectedVerifiers: selectedOptions || [] });
  };
  handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase();
    // Search now runs on the SERVER across ALL patients, so a match is found
    // even if it isn't on the current page. Debounced; resets to page 1.
    this.setState({ search: searchValue, currentPage: 1 });
    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => this.fetchPatients(1), 400);
  };
  handleSort = (field) => {
    const { sortField, sortDirection, data } = this.state;
    const direction =
      sortField === field && sortDirection === "asc" ? "desc" : "asc";

    const sortedRows = [...data.rows].sort((a, b) => {
      if (a[field] < b[field]) return direction === "asc" ? -1 : 1;
      if (a[field] > b[field]) return direction === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      sortField: field,
      sortDirection: direction,
      data: { ...data, rows: sortedRows },
    });
  };
  handlePageSizeChange = (event) => {
    const pageSize = parseInt(event.target.value, 10);
    // Page size is a SERVER param now — refetch page 1 with the new size.
    this.setState({ pageSize, currentPage: 1 }, () => this.fetchPatients(1));
  };

  invertEcg(e) {
    const userid = e.currentTarget.id;
    // console.log(e.currentTarget.id);
    axios.get(
      `https://web.mybiocalculus.com/html/welcome/analyzeAll/?userid=${userid}&&type=/home/ubuntu/web_analysis/single_invert.py`
    );
    axios.get(
      `https://web.mybiocalculus.com/html/welcome/analyzeAll/?userid=${userid}&&type=/home/ubuntu/web_analysis/single_invert.py`
    );
  }
  fetchPatients = (pageNumber) => {
    const pageSize = this.state.pageSize || 50;
    const search = (this.state.search || "").trim();
    axios
      .get(
        apiUrl + "api/users/getSupportPatientsNewmodal?page=" + pageNumber +
          "&limit=" + pageSize +
          (search ? "&search=" + encodeURIComponent(search) : "")
      )
      .then((res) => {
        const patientsList = res.data.patients || [];
        const totalPages = res.data.totalPages || 1;
        const totalCount = res.data.totalCount || 0;

        this.setState({
          patients: patientsList,
          data: patientsList,
          totalPages,
          totalCount,
          hasMore: !!res.data.hasMore,
          customerDetails: patientsList.map((patient) => patient.customer_details),
        });

        // console.log(res.data);

        const data = {
          columns: [
            {
              label: "SL NO",
              field: "slno",
              sort: "asc",
              width: 50,
            },
            {
              label: "PATIENT NAME",
              field: "patientName",
              sort: "asc",
              width: 200,
            },
            {
              label: "Created On",
              field: "Created",
              sort: "asc",
              width: 200,
            },
            {
              label: "Trigger",
              field: "Trigger",
              sort: "asc",
              width: 250,
            },
            {
              label: "Doctor",
              field: "doctorName",
              sort: "asc",
              width: 200,
            },

            {
              label: "Phone",
              field: "phone",
              sort: "asc",
              width: 200,
            },
            {
              label: "Serial No",
              field: "serial_no",
              sort: "asc",
              width: 250,
            },

            {
              label: "Gender",
              field: "gender",
              sort: "asc",
              width: 50,
            },
            {
              label: "Gender",
              field: "gender",
              sort: "asc",
              width: 250,
            },

            {
              label: "Hospital",
              field: "hospital",
              sort: "asc",
              width: 200,
            },
            {
              label: "Duration",
              field: "duration",
              sort: "asc",
              width: 100,
            },
            {
              label: "Mac ID",
              field: "Mac_id",
              sort: "asc",
              width: 400,
            },
            {
              label: "Battery Percentage",
              field: "BatteryPercentage",
              sort: "disabled",
              width: 100,
            },
            {
              label: "Backup Status",
              field: "backup",
              sort: "disabled",
              width: 200,
            },
            {
              label: "Symptoms",
              field: "symptoms",
              sort: "asc",
              width: 200,
            },
            {
              label: "IP/OP",
              field: "ip_op",
              sort: "asc",
              width: 200,
            },
            {
              label: "Patient ID",
              field: "device_id",
              sort: "asc",
              width: 200,
            },
            {
              label: "Recording Status",
              field: "RecordingStatus",
              sort: "asc",
              width: 200,
            },
            {
              label: "Customer",
              field: "customer_details",
              sort: "asc",
              width: 200,
            },

            {
              label: "Invert",
              field: "Invert",
              sort: "disabled",
              width: 200,
            },

            {
              label: "Status",
              field: "status",
              sort: "disabled",
              width: 200,
            },

            {
              label: "Action",
              field: "action",
              sort: "disabled",
              width: 200,
            },
            {
              label: "Diary",
              field: "diary",
              sort: "disabled",
              width: 200,
            },
            {
              label: "",
              field: "serial_o",
              sort: "asc",
              width: 0,
            },
          ],
          rows: [],
        };

        var onClick = this.selectItem.bind(this);
        var getInfo = this.getInfo.bind(this);
        var getCommentInfo = this.getCommentInfo.bind(this);
        var preventDefault = this.preventDefault.bind(this);
        var createdData = "";
        const options = [
          "RPeaks",
          "Classic",
          "Classical",
          "Classic Negative",
          "AI",
          "AIcodes",
        ];
        const defaultOption = options[0];
        patientsList.map(function (patient, i) {
          var url = " ";
          if (patient.LastDatasetId !== undefined) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/verifier-unanalysed/" +
                patient._id +
                "/" +
                patient.LastDatasetId;
            } else {
              url = " ";
            }
          }

          var anl_btn_txt = "Analyze";
          var anl_btn_class = "btn-danger";
          var gen_btn_txt = "Not Analyzed";
          var gen_btn_class = "btn-danger";
          var report_link = "#";
          var report_link_target = "";
          var report_status = patient.report_status;
          window.backup_status = patient.backup_status;
          if (patient.report_status == 1) {
            anl_btn_txt = "Analyzing...";
            gen_btn_txt = "Data is Analyzing";
            gen_btn_class = "btn-warning";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 2) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/verifier-chart/" + patient._id + "/" + patient.LastDatasetId;
            } else {
              url = " ";
            }
            gen_btn_txt = "Analyzed";
            gen_btn_class = "btn-primary";
            anl_btn_txt = "Analyzed";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 4) {
            gen_btn_txt = "Report Complete";
            gen_btn_class = "btn-success";
            report_link_target = "_blank";
            report_link =
              "https://web.mybiocalculus.com/assets/dist/user_records/" +
              patient._id +
              "/Report" +
              patient._id +
              ".pdf";
          }

          if (
            patient.backup_status == 0 ||
            patient.backup_status == undefined
          ) {
            anl_btn_txt = "Analyzed";

            anl_btn_txt = "Analyzed";
          } else if (patient.backup_status == 1) {
            anl_btn_txt = "Retrieve";
          } else if (patient.backup_status == 2) {
            anl_btn_txt = "Retrieving";
          }
          const recordingStatus = patient.RecordingStatus;

          // Function to render status message based on RecordingStatus
          const renderStatusMessage = () => {
            switch (recordingStatus) {
              case 0:
                return " recording Not started";
              case 1:
                return "Recording Mode";
              case 3:
                return "Data uploaded";
              default:
                return "Unknown status";
            }
          };
          // console.log("rec status!!!!!!!!!!!!", renderStatusMessage());
          createdData = patient.created_at.split("T");
          const customerDetailsText = 
            patient.customerName && patient.customerName !== "NA"
              ? patient.customerName
              : patient.customer_details && patient.customer_details.length > 0
                ? patient.customer_details
                    .map((detail) => detail.customer_details)
                    .join(" ")
                : "No customer details available";

          data.rows.push({
            slno: i + 1,
            patientName: patient.name,
            created: createdData[0],

            Trigger: <TriggerModal patient={patient} />,

            doctorName: patient.doctor_name,

            phone: patient.phone,
            serial_no: <Serialno patient={patient} />,
            serial_o: patient.serial_no,
            gender: patient.gender,

            hospital: patient.hospital,
            ActiveMorning:
              patient.ActiveMorning === "NA" || !patient.ActiveMorning
                ? "_"
                : patient.ActiveMorning,
            ActiveEvening:
              patient.ActiveEvening === "NA" || !patient.ActiveEvening
                ? "_"
                : patient.ActiveEvening,

            issuereported: patient.issueReported || "NA",
            duration: patient.exp_device_use_days,
            Mac_id: patient.Mac_id,

            BatteryPercentage: <YourComponent patient={patient} />,
            backup: <BackupButton patient={patient} />,
            symptoms: patient.indication,
            ip_op: patient.ip_op,
            device_id: patient.device_id,
            RecordingStatus: renderStatusMessage(),
            recStatusDisplay: (() => {
              switch (recordingStatus) {
                case 1: return (
                  <span style={{ background:"#d4edda", color:"#155724", borderRadius:"12px", padding:"2px 8px", fontSize:"10px", fontWeight:600, whiteSpace:"nowrap" }}>
                    🟢 In Recording
                  </span>);
                case 3: return (
                  <span style={{ background:"#cce5ff", color:"#004085", borderRadius:"12px", padding:"2px 8px", fontSize:"10px", fontWeight:600, whiteSpace:"nowrap" }}>
                    📡 Data Uploaded
                  </span>);
                default: return (
                  <span style={{ background:"#f8d7da", color:"#721c24", borderRadius:"12px", padding:"2px 8px", fontSize:"10px", fontWeight:600, whiteSpace:"nowrap" }}>
                    🔴 Not Recording
                  </span>);
              }
            })(),
            customer_details: customerDetailsText,
            Invert: (
              <React.Fragment>
                <a href="#">
                  <button
                    type="button"
                    id={patient._id}
                    onClick={this.invertEcg}
                    className="btn btn-warning mr-20"
                    data-toggle="modal"
                  >
                    Invert
                  </button>
                </a>
              </React.Fragment>
            ),
            Status: (
              <React.Fragment>
                <a href="#">
                  <button
                    type="button"
                    id={patient._id}
                    className="btn btn-primary  mr-20"
                  >
                    {gen_btn_txt}
                  </button>
                </a>
              </React.Fragment>
            ),
            action: (
              <button
                type="button"
                id={patient._id}
                onClick={getInfo}
                title="Edit Patient"
                data-toggle="modal"
                data-target="#editInfoModal"
                style={{ background: "none", border: "1px solid #007bff", borderRadius: "4px", padding: "3px 7px", cursor: "pointer", fontSize: "15px" }}
              >
                ✏️
              </button>
            ),
            diary: (
              <button
                type="button"
                id={patient._id}
                title="Add Diary Note"
                data-toggle="modal"
                data-target="#editDiaryModal"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 30,
                  height: 30,
                  background:
                    "linear-gradient(135deg,#1f6e8c 0%,#0c5174 100%)",
                  border: "1px solid #1a3a4d",
                  borderRadius: 6,
                  padding: 0,
                  cursor: "pointer",
                  fontSize: 14,
                  color: "#fff",
                  boxShadow: "0 2px 4px rgba(31,110,140,0.35)",
                  transition:
                    "transform 0.12s ease, box-shadow 0.12s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 8px rgba(31,110,140,0.5)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 2px 4px rgba(31,110,140,0.35)";
                }}
              >
                📓
              </button>
            ),
            comments: (
              <button
                type="button"
                id={patient._id}
                onClick={getCommentInfo}
                title="Comments"
                data-toggle="modal"
                data-target="#commentinfomodal"
                style={{ background: "#1d4a6e", border: "1px solid #2e6fa3", borderRadius: "4px", padding: "3px 8px", cursor: "pointer", fontSize: "14px", color: "#fff", display: "inline-flex", alignItems: "center", gap: 3 }}
              >
                💬 <span style={{ fontSize: "10px", background: patient.comments ? "rgba(255,255,255,0.15)" : "transparent", color: "#aad4f5", borderRadius: 8, padding: "0 3px", fontWeight: 700 }}>
                  {patient.comments ? patient.comments.split("\n").filter(l => l.trim()).length : 0}
                </span>
              </button>
            ),
            report: (() => {
              const rs = patient.report_status || 0;
              const isCompleted = !!(patient.ReportGeneration || rs === 5);
              // Status badge (only shown when NOT completed)
              const statusInfo = !isCompleted
                ? rs === 4 ? { label: "In Preparation",    color: "#2ecd99", bg: "rgba(46,205,153,0.13)" }
                : rs === 3 ? { label: "Verif. Completed",  color: "#a78bfa", bg: "rgba(167,139,250,0.13)" }
                : rs === 2 || rs === 6 ? { label: "Analyze Completed", color: "#5ac8fa", bg: "rgba(90,200,250,0.13)" }
                : rs === 1 ? { label: "Analyzing…",        color: "#ff9f0a", bg: "rgba(255,159,10,0.13)" }
                : { label: "Not Analyzed",                 color: "#7a9ab0", bg: "rgba(122,154,176,0.10)" }
                : null;
              // Format delivery time compactly
              const fmtTime = (raw) => {
                if (!raw) return "";
                const d = new Date(raw);
                if (isNaN(d)) return raw;
                return d.toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true });
              };
              const deliveryTime = patient.mailsentime || patient.whatsappsenttime;
              return (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
                  {/* Status badge — hidden when report is completed */}
                  {statusInfo && (
                    <span style={{ fontSize: "10px", fontWeight: 700, color: statusInfo.color, background: statusInfo.bg, border: `1px solid ${statusInfo.color}55`, borderRadius: 6, padding: "2px 7px", whiteSpace: "nowrap" }}>
                      {statusInfo.label}
                    </span>
                  )}
                  {/* Delivery time — shown only when completed */}
                  {isCompleted && deliveryTime && (
                    <div style={{ fontSize: "9px", color: "#7ab8d8", fontWeight: 600, whiteSpace: "nowrap", lineHeight: 1.4 }}>
                      📬 {fmtTime(deliveryTime)}
                    </div>
                  )}
                  {/* View Report button */}
                  {isCompleted && (
                    <button
                      type="button"
                      title="View Report"
                      style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 8px", fontSize: "11px", background: "#1a4a2e", border: "1px solid #2ecd99", borderRadius: 5, color: "#2ecd99", cursor: "pointer", fontWeight: 600 }}
                      onClick={() => {
                        try {
                          const formattedName = (patient.name || "").replace(/\s+/g, "_");
                          window.open(`${apiUrl3}assets/dist/user_records/${patient.device_id}/Biocalculus_${formattedName}_${patient.device_id}.pdf`, "_blank");
                        } catch (err) { console.error(err); }
                      }}
                    >📄 View Report</button>
                  )}
                  {/* Mail UI removed */}
                  {/* Delivery status icons — very small, shown when completed */}
                  {isCompleted && patient.whatsappsenttime && (
                    <div style={{ display: "flex", gap: 3, alignItems: "center", marginTop: 1 }}>
                      {patient.whatsappsenttime && (
                        <span
                          title={`WhatsApp: ${fmtTime(patient.whatsappsenttime)}`}
                          onClick={() => toast(`📱 WhatsApp sent: ${fmtTime(patient.whatsappsenttime)}`)}
                          style={{ display: "inline-flex", alignItems: "center", gap: 2, background: "rgba(37,211,102,0.12)", border: "1px solid rgba(37,211,102,0.35)", borderRadius: 4, padding: "1px 4px", cursor: "pointer" }}
                        >
                          <img src="../../../whatsapp icon.png" alt="WA" style={{ width: 11, height: 11, objectFit: "contain" }} />
                          <span style={{ fontSize: "9px", color: "#25d366", fontWeight: 700 }}>✓</span>
                        </span>
                      )}
                    </div>
                  )}
                </div>
              );
            })(),
          });
        }, this);
        this.setState({ data: data });
      })
      .catch((err) => {});
  };

  onSubmit = (e) => {
    e.preventDefault();
    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  onSubmitDiary = (e) => {
    e.preventDefault();
    var uid = this.props.userid;
    var did = this.props.databaseid;
    var finTime = document.getElementById("addTime").value;

    const info = {
      id: this.props.userid,
      datetime: finTime,
      diary_notes: this.state.addNote,
      act_duration: this.state.act_duration,
      activity: this.state.activity,
    };
    // console.log("info", info);
    axios
      .post(apiUrl + "api/patients/addDiary", info)
      .then((res) => {
        // console.log(res.data);
        $(".closePopup").click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: this.state.priority,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
      prioritizeData: this.state.prioritizeData, // <-- Add this line
      clinicalCondition: this.state.clinicalCondition, // <-- Add this line
    };
    // console.log("info:", this.state.clinicalCondition);

    const deviceinfoupdate = {
      mac_id: this.state.macid,
      priority: this.state.priority,
    };

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        // Handle the response of the first request
        // console.log("Patient info updated:", res.data);
        if (this.state.macid != null) {
          // If macid is either undefined or null
          return axios.put(
            `${apiUrl}api/patients/updateDevicePriority`,
            deviceinfoupdate
          );
        }
      })

      .then((res) => {
        // Handle the response of the second request
        // console.log("Device priority updated:", res.data);
        $(".closePopup").click();
        this.fetchData(); // Fetch updated data
      })
      .catch((err) => {
        // Handle any errors from either request
        console.error("Error occurred:", err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ [e.target.name]: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }
  Trigger(e) {
    var userid = e.currentTarget.id;

    axios
      .post(`${apiUrl}api/graph/Trigger_button_new`, {
        userid: userid,
      })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  Trigger_old(e) {
    var userid = e.currentTarget.id;

    axios
      .post(`${apiUrl4}api/users/Trigger_button`, { userid })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  nextPage = () => {
    const { currentPage } = this.state;
    const nextPage = currentPage + 1;
    this.setState({ currentPage: nextPage });
    this.fetchPatients(nextPage);
  };

  prevPage = () => {
    const { currentPage } = this.state;
    const prevPage = currentPage - 1;
    if (prevPage > 0) {
      this.setState({ currentPage: prevPage });
      this.fetchPatients(prevPage);
    }
  };

  // Jump straight to a page (clamped to 1..totalPages). With 1000+ pages,
  // Prev/Next alone is impractical — this + search is how you navigate.
  goToPage = (n) => {
    const totalPages = this.state.totalPages || 1;
    const target = Math.max(1, Math.min(parseInt(n, 10) || 1, totalPages));
    if (target === this.state.currentPage) return;
    this.setState({ currentPage: target });
    this.fetchPatients(target);
  };
  setInfo(e) {
    var diary_id = e.currentTarget.id;
    this.state.diary_note_id = diary_id;
    /*var arr=this.search(this.state.diary_notes,diary_id);
     this.setState({time:arr[0].datetime,note:arr[0].diary_notes});
     console.log("diary_id",this.state.diary_note_id);*/
  }
  getInfo(e) {
    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    this.setState({
      userid,
      isModalCompleteOpen: false,
      loadingEditModal: true,
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
    });
    Promise.all([
      axios.get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`),
      axios.get(`${apiUrl}api/users/allverifiers`),
      axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`),
      axios.get(`${apiUrl}api/common/getSupportPerson`),
    ])
      .then(([additionalRes, verifiersRes, verifiedPctRes, supportRes]) => {
        const data = additionalRes.data[0];

        // --- Gender ---
        const g = (data.gender || "").toUpperCase();
        const gender = g === "FEMALE" || g === "F" ? "F" : "M";

        // --- Report status from cached patients ---
        let reportstatus = this.state.reportstatus;
        let comments = this.state.comments;
        let ipop = this.state.ipop;
        if (Array.isArray(this.state.patients)) {
          const match = this.state.patients.find((p) => p._id === userid);
          if (match) {
            reportstatus = match.report_status;
            comments = match.comments;
            ipop = match.ip_op;
          }
        }

        // --- Customer details ---
        let customer_details = this.state.customer_details;
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            customer_details = customer.customer_details;
          }
        });

        // --- DOB formatting ---
        let formattedDob = data.dob;
        if (formattedDob) {
          const dateObj = new Date(formattedDob);
          if (!isNaN(dateObj.getTime())) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            formattedDob = `${mm}/${dd}/${dateObj.getFullYear()}`;
          }
        }

        // --- Verifiers ---
        const formattedVerifiers = verifiersRes.data.map((v) => ({
          value: v._id,
          label: v.name,
          patients: v.patients,
        }));
        const selectedVerifiers = formattedVerifiers.filter((v) =>
          v.patients.includes(userid)
        );

        // --- Verified percentage ---
        const ecgValues = verifiedPctRes.data.ecgValues || [];
        const verifyCount = ecgValues.filter((v) => v.verifyStatus === 1).length;
        const percentageVerified = ecgValues.length > 0
          ? ((verifyCount / ecgValues.length) * 100).toFixed(2)
          : "0.00";

        // --- Support persons ---
        const supportPersons = supportRes.data && Array.isArray(supportRes.data)
          ? supportRes.data
          : this.state.supportPersons;

        // Single batched setState for everything
        this.setState({
          gender,
          reportstatus,
          comments,
          ipop,
          customer_details,
          dob: formattedDob,
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus || "No",
          clinicalCondition: data.clinicalCondition || "",
          verifiers: formattedVerifiers,
          selectedVerifiers,
          percentageVerified,
          supportPersons,
          loadingEditModal: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({
      userid,
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  Downloadcsv = async (param1, param2) => {
    let isReady = false;
    try {
      const prepareUrl = `${apiUrl}api/users/csvfile?param1=${encodeURIComponent(
        param1
      )}&param2=${encodeURIComponent(param2)}`;
      const prepareResponse = await axios.post(prepareUrl, {
        param1,
        param2,
      });
      console.log("prepareResponse:", prepareResponse, param1);
      if (
        prepareResponse.status === 200 &&
        prepareResponse.data.response === 200 &&
        prepareResponse.data.output.includes("Data saved") &&
        prepareResponse.data.returnCode === 0
      ) {
        isReady = true;
      } else {
        toast.error("File is not ready for download.");
      }
    } catch (err) {
      console.error("Preparation Error:", err);
      toast.error("Failed to prepare file for download.");
    } finally {
      if (isReady) {
        try {
          const downloadUrl = `${apiUrl}api/users/download_excel`;
          const response = await axios({
            url: downloadUrl,
            method: "GET",
            responseType: "blob",
          });
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "download.xlsx");
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        } catch (err) {
          console.error("Download Error:", err);
          toast.error("Failed to download file.");
        }
      }
    }
  };
  exportToCSV = () => {
    const { data, sortField, sortDirection } = this.state;

    // Define columns to exclude (you can modify this list based on your needs)
    const excludedColumns = [
      "Trigger",
      "serial_no",
      "backup",
      "Status",
      "action",
      "diary",
      "BatteryPercentage",
    ];

    // Sort the rows if necessary
    const sortedRows = [...data.rows].sort((a, b) => {
      if (sortField && sortDirection) {
        const aValue = a[sortField];
        const bValue = b[sortField];
        if (sortDirection === "asc") {
          return aValue > bValue ? 1 : -1;
        } else {
          return aValue < bValue ? 1 : -1;
        }
      }
      return 0;
    });

    // Filter the rows if needed (e.g., excluding rows with certain conditions)
    const filteredRows = sortedRows.filter((row) => {
      // Example: exclude rows with 'Status' as 'Inactive'
      return row.Status !== "Inactive"; // Modify this based on your needs
    });

    // Prepare headers by excluding specified columns
    const headers = Object.keys(filteredRows[0]).filter(
      (header) => !excludedColumns.includes(header)
    );

    // Convert rows to CSV format, excluding unwanted columns
    const csvRows = [];
    csvRows.push(headers.join(",")); // Add the header row

    filteredRows.forEach((row) => {
      const values = headers.map((header) => {
        const value = row[header] === null ? "" : row[header]; // Handle null values
        return `"${value}"`; // Wrap each value in quotes to handle commas
      });
      csvRows.push(values.join(","));
    });

    // Create CSV string
    const csvString = csvRows.join("\n");

    // Create a temporary link element to trigger the download
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csvString);
    link.target = "_blank";
    link.download = "filtered_sorted_data.csv";

    // Trigger the download
    link.click();
  };

  // Add this method to reset the info modal state
  resetInfoModal = () => {
    // Reset any modal-specific state here if needed
    this.setState({
      loadingEditModal: false,
      // Add any other fields you want to reset when closing the modal
    });
  };

  render() {
    // const { errors, doctors, selectedDoctor,data, search, pageSize, sortField, sortDirection } = this.state;
    // Inside render() method
    const {
      errors,
      doctors,
      selectedDoctor,
      data,
      search,
      pageSize,
      sortField,
      sortDirection,
      dob,
      loadingEditModal,
    } = this.state;

    // Ensure `data` and `data.rows` are defined and check each value before calling `toString()`
    const filteredRows =
      data && data.rows && Array.isArray(data.rows)
        ? data.rows.filter(
            (row) =>
              Object.values(row).some(
                (value) =>
                  // Safely check if value is not undefined or null before calling `toString()`
                  value &&
                  value.toString().toLowerCase().includes(search.toLowerCase())
              ) ||
              // Check if customer_details contains the search value
              (row.customer_details &&
                row.customer_details
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase()))
          )
        : []; // Fallback to empty array if data.rows is undefined

    // Slice rows for pagination
    const displayedRows = filteredRows.slice(0, pageSize);

    // console.log("selecteddoctors:", selectedDoctor);
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    // let doctorsList =
    //   this.state.doctors.length > 0 &&
    //   this.state.doctors.map((item, i) => {
    //     return (
    //       <option
    //         key={i}
    //         value={item._id}
    //         selected={this.state.doctor_name == item.name}
    //       >
    //         {item.name}
    //       </option>
    //     );
    //   }, this);
    // Helper function to call the first API and then enable download

    return (
      <div className="wrapper theme-1-active box-layout pimary-color-green">
        <SideBar menus={this.state.menus} profileLink={this.state.profileLink} />
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "10px" }}>
          <div className="container-fluid">
            {/* ── Diary Notes modal — modern dark-themed redesign ──
                Same form fields and submit handler as the legacy version
                (time / activity / duration / note → onSubmitDiary), so
                the backend contract is unchanged. Visual + accessibility
                pass only. */}
            <div id="editDiaryModal" className="modal fade" role="dialog">
              <div
                className="modal-dialog"
                style={{ maxWidth: "560px" }}
              >
                <div
                  className="modal-content"
                  style={{
                    background: "#0f1117",
                    border: "1px solid #242833",
                    borderRadius: 14,
                    boxShadow: "0 24px 48px rgba(0,0,0,0.45)",
                    color: "#e6e6e6",
                    overflow: "hidden",
                    fontFamily:
                      '"Inter","Segoe UI",system-ui,-apple-system,sans-serif',
                  }}
                >
                  {/* Header */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "16px 20px",
                      background:
                        "linear-gradient(135deg,#1f6e8c 0%,#0c5174 100%)",
                      borderBottom: "1px solid #1a3a4d",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        fontSize: 15,
                        fontWeight: 700,
                        letterSpacing: 0.4,
                        color: "#ffffff",
                      }}
                    >
                      <span aria-hidden="true" style={{ fontSize: 20 }}>📓</span>
                      Add Diary Note
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      style={{
                        background: "rgba(255,255,255,0.12)",
                        border: "none",
                        color: "#fff",
                        width: 30,
                        height: 30,
                        borderRadius: 999,
                        fontSize: 16,
                        cursor: "pointer",
                        opacity: 1,
                        lineHeight: 1,
                      }}
                    >
                      &times;
                    </button>
                  </div>

                  <form method="post" onSubmit={this.onSubmitDiary}>
                    <div style={{ padding: "20px 22px 8px" }}>
                      <p
                        style={{
                          color: "#8a93a0",
                          fontSize: 12,
                          margin: "0 0 18px",
                        }}
                      >
                        Capture what the patient was doing — context helps
                        the verifier interpret the strip.
                      </p>

                      {/* TIME */}
                      <div style={{ marginBottom: 16 }}>
                        <label
                          htmlFor="addTime"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#8a93a0",
                            textTransform: "uppercase",
                            letterSpacing: 0.6,
                            marginBottom: 6,
                          }}
                        >
                          <span aria-hidden="true">🕐</span> Time
                        </label>
                        <input
                          id="addTime"
                          type="text"
                          className={classnames({ "is-invalid": errors.time })}
                          onBlur={this.onChange}
                          value={this.state.time}
                          name="time"
                          placeholder="2026-05-04 14:23"
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            borderRadius: 8,
                            border: "1px solid #2a2f3a",
                            background: "#0c1018",
                            color: "#e6e6e6",
                            fontSize: 13,
                            fontFamily:
                              '"Menlo","Consolas",monospace',
                            outline: "none",
                            transition:
                              "border-color 0.15s, box-shadow 0.15s",
                          }}
                          onFocus={(e) => {
                            e.currentTarget.style.borderColor = "#2eaabb";
                            e.currentTarget.style.boxShadow =
                              "0 0 0 3px rgba(46,170,187,0.18)";
                          }}
                          onBlurCapture={(e) => {
                            e.currentTarget.style.borderColor = "#2a2f3a";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                        />
                      </div>

                      {/* Activity + Duration on one row */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 12,
                          marginBottom: 16,
                        }}
                      >
                        <div>
                          <label
                            htmlFor="diary-activity"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              fontSize: 11,
                              fontWeight: 700,
                              color: "#8a93a0",
                              textTransform: "uppercase",
                              letterSpacing: 0.6,
                              marginBottom: 6,
                            }}
                          >
                            <span aria-hidden="true">🏃</span> Activity
                          </label>
                          <input
                            id="diary-activity"
                            type="text"
                            name="activity"
                            onChange={this.onChange}
                            value={this.state.activity}
                            placeholder="e.g. Walking"
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              borderRadius: 8,
                              border: "1px solid #2a2f3a",
                              background: "#0c1018",
                              color: "#e6e6e6",
                              fontSize: 13,
                              outline: "none",
                            }}
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="diary-duration"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                              fontSize: 11,
                              fontWeight: 700,
                              color: "#8a93a0",
                              textTransform: "uppercase",
                              letterSpacing: 0.6,
                              marginBottom: 6,
                            }}
                          >
                            <span aria-hidden="true">⏱️</span> Duration
                          </label>
                          <input
                            id="diary-duration"
                            type="text"
                            name="act_duration"
                            onChange={this.onChange}
                            value={this.state.act_duration}
                            placeholder="e.g. 15 min"
                            style={{
                              width: "100%",
                              padding: "10px 12px",
                              borderRadius: 8,
                              border: "1px solid #2a2f3a",
                              background: "#0c1018",
                              color: "#e6e6e6",
                              fontSize: 13,
                              outline: "none",
                            }}
                          />
                        </div>
                      </div>

                      {/* Note */}
                      <div style={{ marginBottom: 8 }}>
                        <label
                          htmlFor="diary-note"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            fontSize: 11,
                            fontWeight: 700,
                            color: "#8a93a0",
                            textTransform: "uppercase",
                            letterSpacing: 0.6,
                            marginBottom: 6,
                          }}
                        >
                          <span aria-hidden="true">📝</span> Note
                        </label>
                        <textarea
                          id="diary-note"
                          name="addNote"
                          onChange={this.onChange}
                          value={this.state.addNote}
                          rows={4}
                          placeholder="What was the patient doing? Any symptoms or context?"
                          style={{
                            width: "100%",
                            padding: "10px 12px",
                            borderRadius: 8,
                            border: "1px solid #2a2f3a",
                            background: "#0c1018",
                            color: "#e6e6e6",
                            fontSize: 13,
                            outline: "none",
                            resize: "vertical",
                            minHeight: 90,
                            fontFamily: "inherit",
                            lineHeight: 1.5,
                          }}
                        />
                      </div>
                    </div>

                    {/* Footer */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 8,
                        padding: "12px 22px 20px",
                        borderTop: "1px solid #1a1f29",
                        background: "#0a0d14",
                      }}
                    >
                      <button
                        type="button"
                        className="closePopup"
                        data-dismiss="modal"
                        style={{
                          background: "transparent",
                          color: "#8a93a0",
                          border: "1px solid #2a2f3a",
                          padding: "8px 18px",
                          borderRadius: 8,
                          fontSize: 13,
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          background:
                            "linear-gradient(135deg,#2ecd99 0%,#25a87c 100%)",
                          color: "#fff",
                          border: "none",
                          padding: "8px 22px",
                          borderRadius: 8,
                          fontSize: 13,
                          fontWeight: 700,
                          cursor: "pointer",
                          boxShadow: "0 2px 8px rgba(46,205,153,0.35)",
                        }}
                      >
                        <span aria-hidden="true">＋</span> Save Diary Note
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header" style={{ background: "#24333e", padding: "10px 16px", borderRadius: "6px 6px 0 0" }}>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      onClick={this.resetInfoModal.bind(this)}
                      style={{ color: "#fff", opacity: 0.8, marginTop: 0 }}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title" style={{ color: "#fff", fontSize: "15px", fontWeight: 600 }}>
                      ✏️ Edit Patient
                      {this.state.patient_name ? <span style={{ fontWeight: 400, fontSize: "13px", marginLeft: 8, opacity: 0.75 }}>— {this.state.patient_name}</span> : ""}
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div className="modal-body" style={{ position: "relative", padding: "16px 20px", fontSize: "13px" }}>
                      {/* Loading indicator — thin top bar, never blocks fields */}
                      {this.state.loadingEditModal && (
                        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: 4, background: "linear-gradient(90deg,#3498db 0%,#2ecc71 100%)", zIndex: 10, animation: "loadbar 1s ease-in-out infinite alternate" }}>
                          <style>{`@keyframes loadbar { 0%{opacity:1} 100%{opacity:0.3} }`}</style>
                        </div>
                      )}

                      {/* ── SECTION: Patient Info ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Patient Info</div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Name</label>
                              <input type="text" className="form-control input-sm" name="patient_name" onChange={this.onChange} value={this.state.patient_name} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Email</label>
                              <input type="text" className="form-control input-sm" name="email_id" onChange={this.onChange} value={this.state.email_id} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Phone</label>
                              <input type="text" className="form-control input-sm" name="phone" onChange={this.onChange} value={this.state.phone} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 0 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Hospital</label>
                              <input type="text" className="form-control input-sm" name="hospital" onChange={this.onChange} value={this.state.hospital} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Doctor</label>
                              <Select
                                options={options}
                                value={selectedDoctor}
                                onChange={this.handleDoctorChange}
                                placeholder="Search Doctor"
                                classNamePrefix="react-select"
                                styles={{
                                  control: (base) => ({ ...base, minHeight: 30, height: 30, fontSize: "13px" }),
                                  valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                                  indicatorsContainer: (base) => ({ ...base, height: 30 }),
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>IP/OP</label>
                              <input type="text" className="form-control input-sm" onChange={(e) => this.setState({ ipop: e.target.value })} value={this.state.ipop} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Clinical Settings ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Clinical Settings</div>

                        {/* Row: File Type + Priority + Report Status */}
                        <div className="row" style={{ marginBottom: 4 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>File Type</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["easy","moderate","hard"].map(ft => (
                                <button key={ft} type="button"
                                  onClick={() => this.setState({ filetype: ft })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.filetype === ft ? "#24333e" : "#fff", color: this.state.filetype === ft ? "#fff" : "#333", cursor: "pointer", textTransform: "capitalize", borderRadius: ft === "easy" ? "4px 0 0 4px" : ft === "hard" ? "0 4px 4px 0" : "0" }}
                                >{ft.charAt(0).toUpperCase() + ft.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Priority</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[{v:"1",label:"High",color:"#e74c3c"},{v:"2",label:"Medium",color:"#f39c12"},{v:"3",label:"Normal",color:"#27ae60"}].map((p, i, arr) => (
                                <button key={p.v} type="button"
                                  onClick={() => this.setState({ priority: p.v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "11px", fontWeight: 600, border: "1px solid #ccc", background: String(this.state.priority) === p.v ? p.color : "#fff", color: String(this.state.priority) === p.v ? "#fff" : "#555", cursor: "pointer", borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length - 1 ? "0 4px 4px 0" : "0" }}
                                >{p.label}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Report Status</label>
                            <select className="form-control input-sm" value={this.state.reportstatus} onChange={(e) => this.setState({ reportstatus: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="0">Not Analyzed</option>
                              <option value="2">Analyze Started</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>

                        {/* Row: Indication + Duration + Confirmation */}
                        <div className="row" style={{ marginTop: 8 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Indication</label>
                              <input type="text" className="form-control input-sm" name="indication" onChange={this.onChange} value={this.state.indication} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 6 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Monitoring Duration (Days)</label>
                              <input type="text" className="form-control input-sm" onChange={(e) => this.setState({ duration: e.target.value })} value={this.state.duration} style={{ height: 30, fontSize: "13px" }} />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Confirmation</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[
                                { v: "Yes", color: "#27ae60" },
                                { v: "No",  color: "#e74c3c" },
                                { v: "Hold", color: "#f39c12" },
                              ].map((item, i, arr) => (
                                <button key={item.v} type="button"
                                  onClick={() => {
                                    this.setState({ Confirmation: item.v });
                                    axios.post(`${apiUrl}api/patients/updateConfirmation`, {
                                      userid: this.state.userid,
                                      Confirmation: item.v,
                                    }).catch(err => console.error("Confirmation update error:", err));
                                  }}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", fontWeight: 600, border: "1px solid #ccc", background: this.state.Confirmation === item.v ? item.color : "#fff", color: this.state.Confirmation === item.v ? "#fff" : "#555", cursor: "pointer", borderRadius: i === 0 ? "4px 0 0 4px" : i === arr.length - 1 ? "0 4px 4px 0" : "0" }}
                                >{item.v}</button>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Row: Gender, Atrial Fib, Cardiac Surgery, Pacemaker, Issue Noticed */}
                        <div className="row" style={{ marginTop: 8 }}>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Gender</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["M","F"].map(g => (
                                <button key={g} type="button"
                                  onClick={() => this.setState({ gender: g })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "13px", fontWeight: 600, border: "1px solid #ccc", background: this.state.gender === g ? "#24333e" : "#fff", color: this.state.gender === g ? "#fff" : "#333", cursor: "pointer", borderRadius: g === "M" ? "4px 0 0 4px" : "0 4px 4px 0" }}
                                >{g}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Atrial Fib</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button"
                                  onClick={() => this.setState({ af: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.af === v ? (v === "yes" ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.af === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v === "yes" ? "4px 0 0 4px" : "0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase() + v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Cardiac Surg.</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {["yes","no"].map(v => (
                                <button key={v} type="button"
                                  onClick={() => this.setState({ cardiac_surgery: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.cardiac_surgery === v ? (v === "yes" ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.cardiac_surgery === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v === "yes" ? "4px 0 0 4px" : "0 4px 4px 0", textTransform: "capitalize" }}
                                >{v.charAt(0).toUpperCase() + v.slice(1)}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-2" style={{ paddingRight: 6 }}>
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Pacemaker</label>
                            <div className="btn-group" style={{ width: "100%" }}>
                              {[true,false].map(v => (
                                <button key={String(v)} type="button"
                                  onClick={() => this.setState({ pacemaker: v })}
                                  style={{ flex: 1, padding: "4px 0", fontSize: "12px", border: "1px solid #ccc", background: this.state.pacemaker === v ? (v ? "#e74c3c" : "#27ae60") : "#fff", color: this.state.pacemaker === v ? "#fff" : "#333", cursor: "pointer", borderRadius: v ? "4px 0 0 4px" : "0 4px 4px 0" }}
                                >{v ? "Yes" : "No"}</button>
                              ))}
                            </div>
                          </div>
                          <div className="col-md-4">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 4, display: "block" }}>Issue Noticed</label>
                            <select className="form-control input-sm" value={this.state.issueReport} onChange={(e) => this.setState({ issueReport: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                              <option value="NA">None</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low Data</option>
                              <option value="customer_reject">Customer Reject</option>
                              <option value="battery_issue">Battery Issue</option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* ── SECTION: Support & Assignment ── */}
                      <div style={{ background: "#f8f9fa", borderRadius: "6px", padding: "10px 14px", marginBottom: "10px" }}>
                        <div style={{ fontSize: "11px", fontWeight: 700, color: "#666", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "8px" }}>Support &amp; Assignment</div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-4" style={{ paddingRight: 6 }}>
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Person</label>
                              <select className="form-control input-sm" value={this.state.supportPerson} onChange={(e) => this.setState({ supportPerson: e.target.value })} style={{ height: 30, fontSize: "12px", padding: "2px 6px" }}>
                                <option value="">— None —</option>
                                {this.state.supportPersons && this.state.supportPersons.length > 0
                                  ? this.state.supportPersons.map((person) => (
                                      <option key={person._id} value={person._id}>{person.name}</option>
                                    ))
                                  : <option disabled>Loading...</option>
                                }
                              </select>
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="form-group" style={{ marginBottom: 8 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Support Notes</label>
                              <textarea className="form-control" rows="2" value={this.state.supportedMatter} onChange={(e) => this.setState({ supportedMatter: e.target.value })} placeholder="Enter details..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                        </div>
                        <div className="row" style={{ marginBottom: 6 }}>
                          <div className="col-md-12">
                            <label style={{ color: "#444", fontSize: "12px", marginBottom: 2, display: "block" }}>Assign Verifier</label>
                            <Select
                              isMulti
                              options={this.state.verifiers}
                              value={this.state.selectedVerifiers}
                              onChange={this.handleVerifierChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select verifiers..."
                              menuPlacement="auto"
                              maxMenuHeight={140}
                              styles={{
                                control: (base) => ({ ...base, fontSize: "12px", minHeight: 28, maxHeight: 60, overflowY: "auto" }),
                                valueContainer: (base) => ({ ...base, padding: "2px 6px", flexWrap: "wrap", maxHeight: 54, overflowY: "auto" }),
                                indicatorsContainer: (base) => ({ ...base, height: 28, alignSelf: "flex-start" }),
                                option: (provided, state) => ({ ...provided, backgroundColor: state.isSelected ? "#24333e" : state.isFocused ? "#e5e5e5" : null, color: state.isSelected ? "white" : "black", fontSize: "12px", padding: "4px 10px" }),
                                multiValue: (provided) => ({ ...provided, backgroundColor: "#24333e", margin: "1px 2px" }),
                                multiValueLabel: (provided) => ({ ...provided, color: "white", fontSize: "11px", padding: "1px 4px" }),
                                multiValueRemove: (provided) => ({ ...provided, color: "white", padding: "0 3px" }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group" style={{ marginBottom: 0 }}>
                              <label style={{ color: "#444", fontSize: "12px", marginBottom: 2 }}>Clinical Condition</label>
                              <textarea className="form-control" rows="2" value={this.state.clinicalCondition} onChange={(e) => this.setState({ clinicalCondition: e.target.value })} placeholder="Enter clinical condition..." style={{ fontSize: "13px", resize: "none" }} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer" style={{ padding: "10px 16px", display: "flex", justifyContent: "flex-end", gap: 8 }}>
                      <button type="button" className="btn closePopup" data-dismiss="modal" onClick={this.resetInfoModal.bind(this)} style={{ padding: "6px 20px", fontSize: "13px", background: "#f0f0f0", border: "1px solid #ccc", borderRadius: 4, color: "#444" }}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-success" disabled={this.state.loadingEditModal} style={{ padding: "6px 24px", fontSize: "13px", background: "#27ae60", border: "none", borderRadius: 4, color: "#fff", fontWeight: 600 }}>
                        {this.state.loadingEditModal ? "Saving…" : "✓ Save Changes"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="row" style={{ marginTop: "2.25%" }}>
              <div className="col-sm-12">
                <div
                  className="panel panel-default card-view"
                  style={{ marginTop: "-1%" }}
                >
                  <div className="panel-heading" style={{ background: "linear-gradient(135deg,#1e3a4a,#2a5568)", borderRadius: "6px 6px 0 0", padding: "10px 16px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                      <h6 style={{ color: "#fff", fontWeight: 700, margin: 0, fontSize: "14px", letterSpacing: "0.5px" }}>🏥 Support Home — Patient List</h6>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <input
                        type="text"
                        placeholder="Search patients..."
                        value={this.state.search}
                        onChange={this.handleSearch}
                        style={{
                          color: "black",
                          border: "none",
                          padding: "5px 10px",
                          borderRadius: "4px",
                          fontSize: "12px",
                          width: "180px",
                        }}
                      />

                      <select
                        onChange={this.handlePageSizeChange}
                        value={this.state.pageSize}
                        style={{
                          color: "black",
                          padding: "5px",
                          borderRadius: "4px",
                          backgroundColor: "white",
                        }}
                      >
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                      <button
                        onClick={this.exportToCSV}
                        style={{ padding: "5px 10px", backgroundColor: "#4CAF50", color: "white", border: "none", borderRadius: "4px", fontSize: "12px", cursor: "pointer" }}
                      >
                        Export CSV
                      </button>
                      <button
                        onClick={this.openCsvModal}
                        style={{ padding: "5px 10px", backgroundColor: "#2196F3", color: "white", border: "none", borderRadius: "4px", fontSize: "12px", cursor: "pointer" }}
                      >
                        CSV
                      </button>
                      </div>
                      <Modal
                        isOpen={this.state.showCsvModal}
                        onRequestClose={this.closeCsvModal}
                        contentLabel="CSV Download"
                        style={{
                          content: {
                            color: "black",
                            width: "400px",
                            height: "300px",
                            margin: "auto",
                            marginTop: "10%",
                          },
                        }}
                      >
                        <h2>CSV Download</h2>
                        <div>
                          <label>
                            Start Time:
                            <input
                              type="text"
                              name="csvParam1"
                              value={this.state.csvParam1}
                              onChange={this.handleCsvParamChange}
                              style={{ marginLeft: "10px" }}
                              placeholder="YYYY-MM-DD HH:MM:SS"
                            />
                          </label>
                        </div>
                        <div style={{ marginTop: "10px" }}>
                          <label>
                            End Time :
                            <input
                              type="text"
                              name="csvParam2"
                              value={this.state.csvParam2}
                              onChange={this.handleCsvParamChange}
                              style={{ marginLeft: "10px" }}
                              placeholder="YYYY-MM-DD HH:MM:SS"
                            />
                          </label>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                          <button
                            onClick={this.handleCsvDownload}
                            className="btn btn-success"
                            style={{ marginRight: "10px" }}
                          >
                            Download
                          </button>
                          <button
                            onClick={this.closeCsvModal}
                            className="btn btn-default"
                          >
                            Close
                          </button>
                        </div>
                      </Modal>
                    </div>
                  </div>
                  <div className="panel-wrapper collapse in">
                    <div className="panel-body">
                      <div style={{ overflowX: "auto" }}>
                          <table className="table table-hover" style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                            <colgroup>
                              <col style={{ width: "3%" }} />
                              <col style={{ width: "8%" }} />
                              <col style={{ width: "8%" }} />
                              <col style={{ width: "6%" }} />
                              <col style={{ width: "8%" }} />
                              <col style={{ width: "8%" }} />
                              <col style={{ width: "8%" }} />
                              <col style={{ width: "10%" }} />
                              <col style={{ width: "7%" }} />
                              <col style={{ width: "6%" }} />
                              <col style={{ width: "6%" }} />
                              <col style={{ width: "6%" }} />
                              <col style={{ width: "3%" }} />
                              <col style={{ width: "3%" }} />
                              <col style={{ width: "3%" }} />
                              <col style={{ width: "7%" }} />
                              <col style={{ width: "6%" }} />
                            </colgroup>
                            <thead style={{ backgroundColor: "#2a5568", color: "#fff" }}>
                              <tr>
                                {[
                                  ["slno",             "SL"],
                                  ["device_id",        "Patient ID / Name"],
                                  ["created",          "Created On / IP-OP"],
                                  ["phone",            "Phone"],
                                  ["doctorName",       "Doctor Name"],
                                  ["duration",         "Duration"],
                                  ["customer_details", "Customer Name"],
                                  ["hospital",         "Hospital Name"],
                                  ["serial_o",         "Serial No / MAC ID"],
                                  ["recStatusDisplay", "Status"],
                                  ["BatteryPercentage","Battery %"],
                                  ["action",           "✏️"],
                                  ["diary",            "📓"],
                                  ["comments",         "💬"],
                                  ["Trigger",          "⚡ Trigger"],
                                  ["report",           "📋 Report"],
                                  ["backup",           "Data backup"],
                                ].map(([field, label]) => (
                                  <th
                                    key={field}
                                    onClick={() => this.handleSort(field)}
                                    style={{ textAlign: "center", cursor: "pointer", padding: "8px 6px", fontWeight: 600, fontSize: "11px" }}
                                  >
                                    {label}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {displayedRows.length > 0 ? (
                                displayedRows.map((row, index) => (
                                  <tr key={row._id || index} style={{ verticalAlign: "middle" }}>
                                    {/* SL */}
                                    <td style={{ textAlign: "center", color: "#666" }}>{index + 1}</td>
                                    {/* Patient ID / Name */}
                                    <td style={{ textAlign: "center" }}>
                                      <div style={{ fontWeight: 600, fontSize: "12px" }}>{row.device_id}</div>
                                      <div style={{ fontWeight: 600, fontSize: "12px" }}>{row.patientName}</div>
                                    </td>
                                    {/* Created On / IP-OP */}
                                    <td style={{ textAlign: "center" }}>
                                      <div style={{ fontSize: "11px" }}>{row.created}</div>
                                      {row.ip_op && <div style={{ color: "#666", fontSize: "11px" }}>{row.ip_op}</div>}
                                    </td>
                                    {/* Phone */}
                                    <td style={{ textAlign: "center" }}>{row.phone}</td>
                                    {/* Doctor */}
                                    <td style={{ textAlign: "center" }}>{row.doctorName}</td>
                                    {/* Duration */}
                                    <td style={{ textAlign: "center", fontWeight: 600 }}>{row.duration}</td>
                                    {/* Customer */}
                                    <td style={{ textAlign: "center" }}>{row.customer_details}</td>
                                    {/* Hospital */}
                                    <td style={{ textAlign: "center" }}>{row.hospital}</td>
                                    {/* Serial / MAC */}
                                    <td style={{ textAlign: "center" }}>
                                      <div style={{ fontSize: "11px" }}>{row.serial_no}</div>
                                      <div style={{ color: "#666", fontSize: "10px" }}>{row.Mac_id}</div>
                                    </td>
                                    {/* Recording Status */}
                                    <td style={{ textAlign: "center" }}>{row.recStatusDisplay}</td>
                                    {/* Battery % */}
                                    <td style={{ textAlign: "center" }}>{row.BatteryPercentage}</td>
                                    {/* Edit icon */}
                                    <td style={{ textAlign: "center" }}>{row.action}</td>
                                    {/* Diary icon */}
                                    <td style={{ textAlign: "center" }}>{row.diary}</td>
                                    {/* Comments */}
                                    <td style={{ textAlign: "center" }}>{row.comments}</td>
                                    {/* Trigger */}
                                    <td style={{ textAlign: "center" }}>{row.Trigger}</td>
                                    {/* Report status / View / Send */}
                                    <td style={{ textAlign: "center" }}>{row.report}</td>
                                    {/* Data backup */}
                                    <td style={{ textAlign: "center" }}>{row.backup}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="17" style={{ textAlign: "center", color: "#888", padding: "20px" }}>
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px", padding: "12px 16px", borderTop: "1px solid #1a3a3a", background: "#0a1f20" }}>
                        <button
                          onClick={this.prevPage}
                          disabled={this.state.currentPage === 1}
                          style={{
                            padding: "5px 16px", fontSize: "12px", fontWeight: 600,
                            borderRadius: "6px", border: "1px solid #2eaabb",
                            background: this.state.currentPage === 1 ? "#0f3035" : "#1a5a62",
                            color: this.state.currentPage === 1 ? "#4a7a82" : "#ffffff",
                            cursor: this.state.currentPage === 1 ? "not-allowed" : "pointer",
                            transition: "background 0.2s",
                          }}
                        >
                          ‹ Previous
                        </button>
                        <span style={{ fontSize: "12px", color: "#89a8c0", fontWeight: 600, textAlign: "center", display: "inline-flex", alignItems: "center", gap: 6 }}>
                          Page
                          <input
                            type="number"
                            min={1}
                            max={this.state.totalPages}
                            defaultValue={this.state.currentPage}
                            key={this.state.currentPage}
                            onKeyDown={(e) => { if (e.key === "Enter") this.goToPage(e.target.value); }}
                            onBlur={(e) => { if (e.target.value && Number(e.target.value) !== this.state.currentPage) this.goToPage(e.target.value); }}
                            title="Type a page number and press Enter"
                            style={{ width: 60, padding: "3px 6px", fontSize: "12px", textAlign: "center", borderRadius: 5, border: "1px solid #2eaabb", background: "#0f3035", color: "#ffffff", outline: "none" }}
                          />
                          of {this.state.totalPages}
                        </span>
                        <button
                          onClick={this.nextPage}
                          disabled={this.state.currentPage === this.state.totalPages}
                          style={{
                            padding: "5px 16px", fontSize: "12px", fontWeight: 600,
                            borderRadius: "6px", border: "1px solid #2eaabb",
                            background: this.state.currentPage === this.state.totalPages ? "#0f3035" : "#1a5a62",
                            color: this.state.currentPage === this.state.totalPages ? "#4a7a82" : "#ffffff",
                            cursor: this.state.currentPage === this.state.totalPages ? "not-allowed" : "pointer",
                            transition: "background 0.2s",
                          }}
                        >
                          Next ›
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Comments Modal ── */}
            <div id="commentinfomodal" className="modal fade" role="dialog" aria-hidden="true">
              <div className="modal-dialog" style={{ maxWidth: 580, margin: "50px auto", width: "90%" }}>
                <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>
                  {/* Header */}
                  <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
                        💬 Comments
                      </div>
                      {this.state.patient_name && (
                        <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                          {this.state.patient_name}
                        </div>
                      )}
                    </div>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ×
                    </button>
                  </div>

                  {/* Comment History */}
                  {(() => {
                    const raw = (this.state.comments || "").trim();
                    const lines = raw ? raw.split("\n").filter(l => l.trim()) : [];
                    return (
                      <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: 280, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
                        {lines.length === 0 ? (
                          <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
                        ) : (
                          lines.map((line, idx) => {
                            const byMatch = line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i)
                                         || line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                            const text   = byMatch ? byMatch[1].trim() : line;
                            const author = byMatch ? byMatch[2].trim() : "";
                            const time   = byMatch ? byMatch[3] || "" : "";
                            const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase() : "?";
                            const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                            const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                            return (
                              <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                                  {initials}
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                    {text}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                                    <span style={{ fontWeight: 600, color: "#64748b" }}>{author || "Unknown"}</span>
                                    {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    );
                  })()}

                  {/* New Comment Input */}
                  <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
                    <textarea
                      value={this.state.newComment || ""}
                      onChange={(e) => this.setState({ newComment: e.target.value })}
                      placeholder="Type your observation, finding or note here…"
                      maxLength={300}
                      rows={3}
                      style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6 }}
                      onFocus={e => e.target.style.borderColor = "#4299e1"}
                      onBlur={e => e.target.style.borderColor = "#cbd5e0"}
                    />
                    <div style={{ textAlign: "right", fontSize: "11px", color: (this.state.newComment || "").length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
                      {(this.state.newComment || "").length}/300
                    </div>
                  </div>

                  {/* Footer */}
                  <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>
                      Cancel
                    </button>
                    <button id={this.state.userid} type="button" onClick={this.submitComment}
                      disabled={!(this.state.newComment || "").trim()}
                      style={{ padding: "7px 22px", fontSize: "13px", background: (this.state.newComment || "").trim() ? "#1e8449" : "#a8d5b5", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: (this.state.newComment || "").trim() ? "pointer" : "not-allowed" }}>
                      ✓ Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Share Report Modal removed */}

        </div>
        </div>
      </div>
    );
  }
}
class YourComponent extends Component {
  state = {
    showModal: false,
    batteryPercentage: null,
  };

  BatteryPercentageClicked = (e) => {
    var userid = e.currentTarget.id;
    axios
      .get(`${apiUrl}api/common/getbatterypercentage?userid=${userid}`)
      .then((res) => {
        // console.log(res.data);
        this.setState({ batteryPercentage: res.data.output, showModal: true });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, batteryPercentage } = this.state;
    const pct = patient.BatteryPercentage || 0;
    const fillColor = pct > 50 ? "#28a745" : pct > 20 ? "#ffc107" : "#dc3545";
    const fillWidth = Math.round(28 * Math.min(100, Math.max(0, pct)) / 100);

    return (
      <>
        <button
          type="button"
          id={patient._id}
          onClick={this.BatteryPercentageClicked}
          title={`Battery: ${pct}%`}
          style={{ background: "none", border: "none", cursor: "pointer", padding: "2px", lineHeight: 1 }}
        >
          <svg width="48" height="22" viewBox="0 0 48 22" xmlns="http://www.w3.org/2000/svg">
            <rect x="1" y="3" width="40" height="16" rx="2" ry="2" fill="none" stroke="#777" strokeWidth="1.5"/>
            <rect x="41" y="8" width="5" height="6" rx="1" ry="1" fill="#777"/>
            <rect x="2.5" y="4.5" width={Math.round(36 * Math.min(100, Math.max(0, pct)) / 100)} height="13" rx="1.5" fill={fillColor}/>
            <text x="21" y="15.5" textAnchor="middle" fontSize="9" fill="#fff" fontWeight="bold" style={{ textShadow: "0 0 2px #000" }}>{pct}%</text>
          </svg>
        </button>

        <Modal
          isOpen={showModal}
          onRequestClose={this.handleCloseModal}
          contentLabel="Battery Percentage"
          style={{
            content: {
              color: "black",
              width: "50%",
              maxWidth: "800px",
              margin: "auto",
            },
          }}
        >
          <h2 style={{ color: "black" }}>Battery Percentage</h2>
          {batteryPercentage !== null ? (
            <p style={{ color: "black" }}>
              Battery percentage is:{" "}
              {batteryPercentage.split("\n").map((item, key) => {
                return (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                );
              })}
            </p>
          ) : (
            <p style={{ color: "black" }}>Loading...</p>
          )}
          <button onClick={this.handleCloseModal}></button>
        </Modal>
      </>
    );
  }
}
class Serialno extends Component {
  state = {
    showModal: false,
    serialno: null,
  };

  serialnoClicked = (e) => {
    // console.log(e.currentTarget.id);
    var mac_id = e.currentTarget.id;

    axios
      .get(`${apiUrl}api/users/getSubsribe`, { params: { mac_id } })
      .then((res) => {
        // console.log(res.data);
        this.setState({ serialno: res.data.data, showModal: true });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, serialno, currentPage, errors } = this.state;

    return (
      <>
        <button
          type="button"
          className="serialno_button"
          id={patient.Mac_id}
          onClick={this.serialnoClicked}
        >
          {patient.serial_no}
        </button>

        {serialno && (
          <Modal
            isOpen={showModal}
            onRequestClose={this.handleCloseModal}
            contentLabel="Records"
            style={{
              content: {
                color: "black",
                width: "60%",
                margin: "auto",
                marginTop: "6%",
              },
            }}
          >
            <h2 style={{ color: "black" }}>Records</h2>

            <p style={{ color: "black", fontSize: "15px" }}>
              {serialno
                .replace(/{"response":200}/g, "") // Remove {"response":200} from the string
                .split("\n")
                .map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                    <br />
                  </span>
                ))}
            </p>
          </Modal>
        )}
      </>
    );
  }
}
class BackupButton extends Component {
  state = {
    backup_status: this.props.patient.backup_status != null ? this.props.patient.backup_status : 0,
    open: false,
  };

  _menuRef = React.createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }
  handleOutsideClick = (e) => {
    if (this._menuRef.current && !this._menuRef.current.contains(e.target)) {
      this.setState({ open: false });
    }
  };

  call = async (action) => {
    const { _id } = this.props.patient;
    const endpoints = {
      doNotBackup: { url: `${apiUrl}api/common/doNotBackup`,  next: 2, busy: null },
      forceBackup:  { url: `${apiUrl}api/common/forceBackup`, next: 3, busy: 3 },
      restoreData:  { url: `${apiUrl}api/common/restoreData`, next: 4, busy: 4 },
    };
    const cfg = endpoints[action];
    this.setState({ backup_status: cfg.next, open: false });
    try {
      const res = await axios.post(cfg.url, { userid: _id });
      const finalStatus = action === "doNotBackup" ? 2
        : action === "forceBackup" ? 1
        : 0;
      this.setState({ backup_status: finalStatus });
      toast.success(res.data.message || "Done");
    } catch (err) {
      const revert = this.props.patient.backup_status || 0;
      this.setState({ backup_status: revert });
      toast.error(err.response?.data?.error || "Action failed");
    }
  };

  render() {
    const { backup_status, open } = this.state;

    const STATUS = {
      0: { label: "Not Backed Up",  icon: "🔴", color: "#ff453a", bg: "rgba(255,69,58,0.15)",  border: "rgba(255,69,58,0.4)"  },
      1: { label: "Backed Up",      icon: "🟢", color: "#30d158", bg: "rgba(48,209,88,0.15)",   border: "rgba(48,209,88,0.4)"  },
      2: { label: "Do Not Backup",  icon: "⚫", color: "#8e8e93", bg: "rgba(142,142,147,0.15)", border: "rgba(142,142,147,0.4)"},
      3: { label: "Backing Up…",    icon: "⏳", color: "#ff9f0a", bg: "rgba(255,159,10,0.15)",  border: "rgba(255,159,10,0.4)" },
      4: { label: "Restoring…",     icon: "⏳", color: "#5ac8fa", bg: "rgba(90,200,250,0.15)",  border: "rgba(90,200,250,0.4)" },
    };
    const s = STATUS[backup_status] || STATUS[0];
    const busy = backup_status === 3 || backup_status === 4;

    const menuItems = [
      {
        key: "doNotBackup",
        icon: "🚫",
        label: "Do Not Backup",
        disabled: backup_status === 2 || busy,
        color: "#8e8e93",
      },
      {
        key: "forceBackup",
        icon: "⬆",
        label: "Force Backup",
        disabled: backup_status === 1 || busy,
        color: "#ff9f0a",
      },
      {
        key: "restoreData",
        icon: "⬇",
        label: "Restore Data",
        disabled: backup_status !== 1 || busy,
        color: "#5ac8fa",
      },
    ];

    return (
      <div ref={this._menuRef} style={{ position: "relative", display: "inline-block" }}>
        {/* Status badge / trigger */}
        <button
          onClick={() => !busy && this.setState({ open: !open })}
          disabled={busy}
          style={{
            display: "inline-flex", alignItems: "center", gap: "4px",
            fontSize: "10px", fontWeight: 700, padding: "2px 7px",
            borderRadius: "10px", border: `1px solid ${s.border}`,
            background: s.bg, color: s.color,
            cursor: busy ? "not-allowed" : "pointer", whiteSpace: "nowrap",
          }}
        >
          {s.icon} {s.label} {!busy && <span style={{ fontSize: "8px", opacity: 0.7 }}>▾</span>}
        </button>

        {/* Dropdown menu */}
        {open && (
          <div style={{
            position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 9999,
            background: "#0f2a2e", border: "1px solid #1e4a52", borderRadius: "8px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.5)", minWidth: "150px", overflow: "hidden",
          }}>
            {menuItems.map((item) => (
              <button
                key={item.key}
                onClick={() => !item.disabled && this.call(item.key)}
                style={{
                  display: "flex", alignItems: "center", gap: "7px",
                  width: "100%", padding: "7px 12px", background: "none",
                  border: "none", textAlign: "left", fontSize: "11px",
                  fontWeight: 600, color: item.disabled ? "#3a5a62" : item.color,
                  cursor: item.disabled ? "not-allowed" : "pointer",
                  borderBottom: "1px solid #1a3a3e",
                }}
                onMouseEnter={(e) => { if (!item.disabled) e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "none"; }}
              >
                <span style={{ fontSize: "13px" }}>{item.icon}</span>
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }
}
// Small chip used by TriggerModal's result panel for counts and
// device-id badges. Kept module-scope so renderOutput stays compact.
const pill = (color) => ({
  display: "inline-block",
  background: color,
  color: "#fff",
  padding: "1px 8px",
  borderRadius: 999,
  fontWeight: 700,
  fontSize: 11,
  marginLeft: 4,
  marginRight: 2,
});

// ── TriggerModal ──────────────────────────────────────────────────────
// Simplified per support request:
//   • Patient-id input is hidden — the row's _id is sent automatically.
//   • Old vs. New distinction is gone — there's a single Trigger button.
//   • The only user-facing input is the web platform (web1 / web2 / web3
//     / web4). That is the "one argument" the trigger action takes.
//   • Result panel highlights "N files < 40 KB" and flags patient-id
//     mismatches between this row and any .txt the backend opens.
class TriggerModal extends Component {
  state = {
    showModal: false,
    action: "script",  // DEFAULT = the separate script (runPatientScript)
    web: "web1",       // used only when a web1..web4 trigger is chosen
    busy: false,
    output: null,
  };

  open = () => {
    this.setState({ showModal: true, action: "script", web: "web1", busy: false, output: null });
  };

  close = () => this.setState({ showModal: false });

  // Small chip used to render counts and device-id badges in the
  // result panel. Kept as a local helper to avoid scattering inline
  // styles all through renderOutput.
  // (declared as a static-shaped value via the arrow style prop function below)

  // The single trigger action. Sends the row's device_id (what the
  // Python load_and_check.py script needs as arg 1), plus the selected
  // web platform (arg 2). The patient _id is included so the Node route
  // can do auth lookups, but the script itself only consumes device_id
  // + web.
  fire = () => {
    const patient = this.props.patient || {};
    const userid = patient._id;
    const device_id = patient.device_id || patient.deviceId;
    const { web, action } = this.state;
    if (!device_id) {
      this.setState({
        output: "No device_id on this patient row — cannot trigger.",
      });
      return;
    }

    this.setState({ busy: true, output: null });

    // Second action — run a separate Python script. Sends BOTH ids so the
    // backend can pass whichever the script expects (user id / device id).
    // No web platform needed — it's a local script run.
    if (action === "script") {
      axios
        .post(`${apiUrl}api/common/runPatientScript`, { userid, device_id })
        .then((res) => this.setState({ busy: false, output: res.data }))
        .catch((err) =>
          this.setState({
            busy: false,
            output:
              (err.response && err.response.data) ||
              "Error running script — check the server logs.",
          })
        );
      return;
    }

    // Standard trigger (load_and_check.py) — needs the web platform.
    if (!web) {
      this.setState({ busy: false, output: "Pick a web platform first." });
      return;
    }
    // Use apiUrl (the main web1 backend that hosts common.js routes).
    // apiUrl2 points at data.mybiocalculus.com which already includes
    // "/api/" in its base, so prefixing "api/common/..." there would
    // produce "/api/api/common/triggerPatient" and 404.
    axios
      .post(`${apiUrl}api/common/triggerPatient`, { userid, device_id, web })
      .then((res) => this.setState({ busy: false, output: res.data }))
      .catch((err) =>
        this.setState({
          busy: false,
          output:
            (err.response && err.response.data) ||
            "Error fetching data — check the server logs.",
        })
      );
  };

  // Render the response payload from load_and_check.py (forwarded by the
  // /triggerPatient Node route). Expected shape:
  //   {
  //     status:         "ok" | "mismatch" | "trigger_failed" | "error",
  //     triggered:      bool,
  //     deviceId:       "243476",
  //     fileDeviceIds:  ["243476"]              // distinct device_ids
  //                                                read from file headers
  //     filesCount:     12,
  //     filesUnder40Kb: 8,
  //     message:        "...",
  //     ...
  //   }
  // Plain-string responses (legacy / error pages) still render in a <pre>
  // block as a graceful fallback.
  renderOutput = () => {
    const { output } = this.state;
    if (!output) return null;
    const currentDeviceId =
      (this.props.patient && (this.props.patient.device_id ||
                              this.props.patient.deviceId)) || "";

    // Shape: structured object
    if (output && typeof output === "object" && !Array.isArray(output)) {
      const status = output.status || "ok";
      const triggered = !!output.triggered;
      const filesCount = output.filesCount;
      const small = output.filesUnder40Kb !== undefined
        ? output.filesUnder40Kb : output.smallFileCount;
      const fileDeviceIds = Array.isArray(output.fileDeviceIds)
        ? output.fileDeviceIds : [];
      const sole = fileDeviceIds.length === 1 ? fileDeviceIds[0] : null;
      const isMismatch = status === "mismatch" ||
        (sole && currentDeviceId && String(sole) !== String(currentDeviceId)) ||
        fileDeviceIds.length > 1;

      const headerColor =
        status === "ok"             ? "#27ae60" :
        status === "mismatch"       ? "#e67e22" :
        status === "trigger_failed" ? "#c0392b" :
        status === "error"          ? "#c0392b" : "#555";
      const headerLabel =
        status === "ok"             ? "✓ Trigger completed" :
        status === "mismatch"       ? "⚠ Mismatch — trigger skipped" :
        status === "trigger_failed" ? "✗ Trigger failed" :
        status === "error"          ? "✗ Error" : "Result";

      return (
        <div
          style={{
            marginTop: "10px",
            padding: "10px",
            background: "#f8f9fa",
            borderRadius: "6px",
            border: "1px solid #e6e9ec",
            fontSize: "12px",
            color: "#333",
          }}
        >
          <div style={{ color: headerColor, fontWeight: 700, marginBottom: 8 }}>
            {headerLabel}
          </div>

          {/* Counts row — files total + files < 40 KB */}
          {(filesCount !== undefined || small !== undefined) && (
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 8 }}>
              {filesCount !== undefined && (
                <div>
                  <strong>Files:</strong>{" "}
                  <span style={pill("#3498db")}>{filesCount}</span>
                </div>
              )}
              {small !== undefined && (
                <div>
                  <strong>&lt; 40 KB:</strong>{" "}
                  <span style={pill("#27ae60")}>{small}</span>
                </div>
              )}
            </div>
          )}

          {/* Device-id reading from file headers */}
          {fileDeviceIds.length > 0 && (
            <div style={{ marginBottom: 8 }}>
              <strong>Device ID in files:</strong>{" "}
              {fileDeviceIds.map((d, i) => (
                <span
                  key={d + i}
                  style={pill(
                    String(d) === String(currentDeviceId) ? "#27ae60" : "#e67e22"
                  )}
                >
                  {d}
                </span>
              ))}
              {currentDeviceId && (
                <span style={{ marginLeft: 8, color: "#888" }}>
                  (this row: <code>{String(currentDeviceId)}</code>)
                </span>
              )}
            </div>
          )}

          {isMismatch && (
            <div
              style={{
                color: "#c0392b",
                margin: "6px 0",
                background: "rgba(230,126,34,0.10)",
                border: "1px solid rgba(230,126,34,0.40)",
                padding: "6px 8px",
                borderRadius: 4,
              }}
            >
              ⚠ Files don't match this patient's device. Trigger was{" "}
              {triggered ? "still fired" : "skipped"}. Verify the device_id
              inside the .txt file headers before retrying.
            </div>
          )}

          {triggered && status === "ok" && !isMismatch && (
            <div style={{ color: "#27ae60", margin: "6px 0" }}>
              ✓ Files match — loaded into this patient on{" "}
              <strong>{output.webPlatform || "the selected web"}</strong>.
            </div>
          )}

          {output.message && (
            <div style={{ color: "#555", marginBottom: 8 }}>
              {String(output.message)}
            </div>
          )}

          {/* Execution response — promoted from the collapsed details so
              the operator sees the trigger script's output immediately.
              Shown only when the trigger actually ran (i.e. status was
              not "mismatch", which has no script output). */}
          {(output.triggerStdout || output.triggerStderr) && (
            <div style={{ marginTop: 8 }}>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 700,
                  color: "#444",
                  marginBottom: 4,
                  textTransform: "uppercase",
                  letterSpacing: 0.4,
                }}
              >
                Execution response
              </div>
              {output.triggerStdout && (
                <pre
                  style={{
                    margin: "0 0 6px",
                    padding: "8px 10px",
                    background: "#0e1218",
                    color: "#d2dae2",
                    border: "1px solid #1f2630",
                    borderRadius: 4,
                    fontFamily: 'Menlo, Consolas, "Courier New", monospace',
                    fontSize: 11,
                    lineHeight: 1.45,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    maxHeight: 240,
                    overflow: "auto",
                  }}
                >
                  {String(output.triggerStdout).trim() || "(no stdout)"}
                </pre>
              )}
              {output.triggerStderr &&
                String(output.triggerStderr).trim() !== "" && (
                  <pre
                    style={{
                      margin: 0,
                      padding: "8px 10px",
                      background: "#2a1414",
                      color: "#ffb4ab",
                      border: "1px solid #5b1f1f",
                      borderRadius: 4,
                      fontFamily:
                        'Menlo, Consolas, "Courier New", monospace',
                      fontSize: 11,
                      lineHeight: 1.45,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      maxHeight: 200,
                      overflow: "auto",
                    }}
                    title="Standard error"
                  >
                    {String(output.triggerStderr).trim()}
                  </pre>
                )}
            </div>
          )}

          <details style={{ marginTop: 8 }}>
            <summary style={{ cursor: "pointer", color: "#888" }}>
              Raw JSON response
            </summary>
            <pre
              style={{
                margin: "6px 0 0",
                padding: "6px",
                background: "#fff",
                border: "1px solid #ececec",
                borderRadius: 4,
                fontSize: 11,
                whiteSpace: "pre-wrap",
                wordBreak: "break-all",
                maxHeight: 220,
                overflow: "auto",
              }}
            >
              {JSON.stringify(output, null, 2)}
            </pre>
          </details>
        </div>
      );
    }

    // Plain string fallback
    return (
      <p
        style={{
          color: "#333",
          marginTop: "10px",
          fontSize: "12px",
          background: "#f8f9fa",
          padding: "10px",
          borderRadius: "6px",
          whiteSpace: "pre-wrap",
        }}
      >
        {String(output)}
      </p>
    );
  };

  render() {
    const { showModal, busy, web, action } = this.state;
    const patientName =
      (this.props.patient && this.props.patient.name) || "Patient";

    return (
      <>
        <button
          type="button"
          onClick={this.open}
          title="Trigger Patient"
          style={{
            background: "none",
            border: "1px solid #e67e22",
            borderRadius: "4px",
            padding: "3px 8px",
            cursor: "pointer",
            fontSize: "15px",
          }}
        >
          ⚡
        </button>
        <Modal
          isOpen={showModal}
          onRequestClose={this.close}
          contentLabel="Trigger"
          style={{
            overlay: { backgroundColor: "rgba(0,0,0,0.4)" },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%,-50%)",
              width: "440px",
              padding: "0",
              borderRadius: "6px",
              overflow: "hidden",
            },
          }}
        >
          {/* Header */}
          <div
            style={{
              background: "#2a5568",
              padding: "10px 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ color: "#fff", fontWeight: 700, fontSize: "14px" }}>
              ⚡ Trigger — {patientName}
            </span>
            <button
              onClick={this.close}
              style={{
                background: "none",
                border: "none",
                color: "#fff",
                fontSize: "18px",
                cursor: "pointer",
              }}
            >
              ×
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "16px" }}>
            <p style={{ color: "#555", fontSize: "12px", margin: "0 0 12px" }}>
              Pick an action and click Trigger. The patient is determined
              automatically from the row.
            </p>

            {/* Single selector — the web platforms (standard trigger) and the
                separate script action live in ONE dropdown. Defaults to web1. */}
            <div style={{ marginBottom: "12px" }}>
              <label
                htmlFor="trigger-action-select"
                style={{
                  display: "block",
                  color: "#333",
                  fontSize: "12px",
                  fontWeight: 600,
                  marginBottom: 4,
                }}
              >
                Action
              </label>
              <select
                id="trigger-action-select"
                className="form-control"
                value={action === "script" ? "script" : "standard:" + web}
                disabled={busy}
                onChange={(e) => {
                  const v = e.target.value;
                  if (v === "script") {
                    this.setState({ action: "script", output: null });
                  } else {
                    this.setState({
                      action: "standard",
                      web: v.split(":")[1] || "web1",
                      output: null,
                    });
                  }
                }}
                style={{ fontSize: "13px" }}
              >
                <option value="script">Run Python script (default)</option>
                <option value="standard:web1">Trigger — web1</option>
                <option value="standard:web2">Trigger — web2</option>
                <option value="standard:web3">Trigger — web3</option>
                <option value="standard:web4">Trigger — web4</option>
                <option value="standard:web5">Trigger — web5</option>
              </select>
            </div>

            {/* Single trigger action */}
            <button
              type="button"
              onClick={this.fire}
              disabled={busy}
              style={{
                width: "100%",
                padding: "10px 16px",
                background: busy ? "#7f8c8d" : "#2ecd99",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                fontWeight: 700,
                fontSize: 13,
                cursor: busy ? "wait" : "pointer",
                transition: "background 0.15s ease",
              }}
            >
              {busy ? "Working…" : "▶ Trigger"}
            </button>

            {this.renderOutput()}

            <div style={{ marginTop: 12, textAlign: "right" }}>
              <button
                type="button"
                className="btn btn-default btn-sm"
                onClick={this.close}
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
class TriggerOldModal extends Component {
  state = {
    showModal: false,
    triggerOldOutput: null,
    userid: "",
    web: "",
    patientid: "",
    errors: {},
  };

  handleTriggerOldClick = () => {
    const defaultUserId = this.props.patient && this.props.patient._id ? this.props.patient._id : "";
    this.setState({
      showModal: true,
      triggerOldOutput: null,
      userid: defaultUserId,
      web: "",
      patientid: "",
      errors: {},
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  validateForm = () => {
    const errors = {};
    const { web } = this.state;

    if (!web || !web.trim()) {
      errors.web = "Web is required";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleTriggerOldSubmit = (e) => {
    e.preventDefault();
    if (!this.validateForm()) {
      return;
    }

    const { userid, web, patientid } = this.state;
    const payload = {
      userid: userid.trim(),
      web: web.trim(),
    };

    if (patientid && patientid.trim()) {
      payload.patientid = patientid.trim();
    }

    axios
      .post("https://web.mybiocalculus.com:3002/api/users/Trigger_button", payload)
      .then((res) => {
        this.setState({
          triggerOldOutput: res.data.output || res.data,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({
          triggerOldOutput: "Error fetching data",
        });
      });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, triggerOldOutput, web, patientid, errors } = this.state;
    return (
      <>
        <button
          type="button"
          className="btn btn-warning mr-20"
          id={patient._id}
          onClick={this.handleTriggerOldClick}
        >
          Trigger Old
        </button>
        <Modal
          isOpen={showModal}
          onRequestClose={this.handleCloseModal}
          contentLabel="Trigger Old Response"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0)",
              backdropFilter: "none",
              WebkitBackdropFilter: "none",
            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              color: "black",
              width: "28%",
              maxWidth: "420px",
              padding: "10px",
            },
          }}
        >
          <h2 style={{ color: "black", margin: "0 0 8px 0", fontSize: "20px" }}>Trigger Old</h2>
          <form onSubmit={this.handleTriggerOldSubmit}>
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "flex-start",
                marginBottom: "8px",
              }}
            >
              <div style={{ flex: 1 }}>
                <label style={{ color: "black", display: "block" }}>Web *</label>
                <select
                  name="web"
                  value={web}
                  onChange={this.handleInputChange}
                  className="form-control"
                  required
                >
                  <option value="">Select</option>
                  <option value="web1">web1</option>
                  <option value="web2">web2</option>
                  <option value="web4">web4</option>
                  <option value="web5">web5</option>
                </select>
                {errors.web ? (
                  <small style={{ color: "red", display: "block", marginTop: "2px" }}>{errors.web}</small>
                ) : null}
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ color: "black", display: "block" }}>Patientid (Optional)</label>
                <input
                  type="text"
                  name="patientid"
                  value={patientid}
                  onChange={this.handleInputChange}
                  className="form-control"
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px", marginTop: "6px" }}>
              <button type="submit" className="btn btn-success">
                Submit
              </button>
              <button type="button" onClick={this.handleCloseModal} className="btn btn-default">
                Close
              </button>
            </div>
          </form>
          {triggerOldOutput ? (
            <p style={{ color: "black", marginTop: "8px", marginBottom: "8px" }}>
              {String(triggerOldOutput)
                .split("\n")
                .map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                ))}
            </p>
          ) : null}
        </Modal>
      </>
    );
  }
}
class TriggerNewModal extends Component {
  state = {
    showModal: false,
    triggerNewOutput: null,
    userid: "",
    web: "",
    patientid: "",
    errors: {},
  };

  handleTriggerNewClick = () => {
    const defaultUserId = this.props.patient && this.props.patient._id ? this.props.patient._id : "";
    console.log("[Trigger New] fetched userid on modal open:", defaultUserId);
    this.setState({
      showModal: true,
      triggerNewOutput: null,
      userid: defaultUserId,
      web: "",
      patientid: "",
      errors: {},
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: "",
      },
    }));
  };

  validateForm = () => {
    const errors = {};
    const { web } = this.state;

    if (!web || !web.trim()) {
      errors.web = "Web is required";
    }

    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleTriggerNewSubmit = (e) => {
    e.preventDefault();
    if (!this.validateForm()) {
      return;
    }

    const { userid, web, patientid } = this.state;
    console.log("[Trigger New] submitting with userid:", userid);
    console.log("[Trigger New] submitting with web:", web);
    const payload = {
      userid: userid.trim(),
      web: web.trim(),
    };

    if (patientid && patientid.trim()) {
      payload.patientid = patientid.trim();
    }

    axios
      .post(`${apiUrl}api/common/triggerPatient`, { userid, patientid, web })
      .then((res) => {
        this.setState({
          triggerNewOutput: res.data.output || res.data,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
        this.setState({
          triggerNewOutput: "Error fetching data",
        });
      });
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { patient } = this.props;
    const { showModal, triggerNewOutput, web, patientid, errors } = this.state;
    return (
      <>
        <button
          type="button"
          className="btn btn-warning mr-20"
          id={patient._id}
          onClick={this.handleTriggerNewClick}
        >
          Trigger New
        </button>
        <Modal
          isOpen={showModal}
          onRequestClose={this.handleCloseModal}
          contentLabel="Trigger New Response"
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0)",
              backdropFilter: "none",
              WebkitBackdropFilter: "none",
            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              color: "black",
              width: "28%",
              maxWidth: "420px",
              padding: "10px",
            },
          }}
        >
          <h2 style={{ color: "black", margin: "0 0 8px 0", fontSize: "20px" }}>Trigger New</h2>
          <form onSubmit={this.handleTriggerNewSubmit}>
            <div
              style={{
                display: "flex",
                gap: "12px",
                alignItems: "flex-start",
                marginBottom: "8px",
              }}
            >
              <div style={{ flex: 1 }}>
                <label style={{ color: "black", display: "block" }}>Web *</label>
                <select
                  name="web"
                  value={web}
                  onChange={this.handleInputChange}
                  className="form-control"
                  required
                >
                  <option value="">Select</option>
                  <option value="web1">web1</option>
                  <option value="web2">web2</option>
                  <option value="web4">web4</option>
                  <option value="web5">web5</option>
                </select>
                {errors.web ? (
                  <small style={{ color: "red", display: "block", marginTop: "2px" }}>{errors.web}</small>
                ) : null}
              </div>
              <div style={{ flex: 1 }}>
                <label style={{ color: "black", display: "block" }}>Patientid (Optional)</label>
                <input
                  type="text"
                  name="patientid"
                  value={patientid}
                  onChange={this.handleInputChange}
                  className="form-control"
                />
              </div>
            </div>
            <div style={{ display: "flex", gap: "8px", marginTop: "6px" }}>
              <button type="submit" className="btn btn-success">
                Submit
              </button>
              <button type="button" onClick={this.handleCloseModal} className="btn btn-default">
                Close
              </button>
            </div>
          </form>
          {triggerNewOutput ? (
            <p style={{ color: "black", marginTop: "8px", marginBottom: "8px" }}>
              {String(triggerNewOutput)
                .split("\n")
                .map((item, key) => (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                ))}
            </p>
          ) : null}
        </Modal>
      </>
    );
  }
}

export default PatientInfo;
